/* globals Detectizr*/
var app = new function() {

  this.objects = {};

  this.settings = {
    easing: 'easeInOutQuart',
    easingIn: 'easeInQuart',
    easingOut: 'easeOutQuart',
    easingInOut: 'easeInOutQuart',
    duration: 200,
  };

  this.names = {
    isActive: 'is-active',
    isOpen: 'is-open',
    isHidden: 'is-hidden',
  };

  this.vars = {
    pageInitialized: false,
    recaptchaScriptLoaded: false,
    sliderInterval: 0,
    currentScroll: 0
  };

  this.init = function() {
    var self = this;
  
    Detectizr.detect({detectScreen:false});

    if (!self.vars.pageInitialized) {
      self.vars.pageInitialized = true;
      app.objects.initModules = new initModules($('body'));
    }

  };

  this.replaceSVG = function() {
    // if (!Modernizr.svg || Detectizr.browser.name == 'ie' || Detectizr.browser.name == 'edge') {
    //   $('img[src*="svg"]').attr('src', function() {
    //     return $(this).attr('src').replace('.svg', '.png');
    //   });
    // }
  };

  this.disableScroll = function() {
    if (window.addEventListener) { // older FF
        window.addEventListener('DOMMouseScroll', this.preventDefault, false);
    }
    window.onwheel = this.preventDefault; // modern standard
    window.onmousewheel = document.onmousewheel = this.preventDefault; // older browsers, IE
    window.ontouchmove  = this.preventDefault; // mobile
    document.onkeydown  = this.preventDefaultForScrollKeys;
  };

  this.enableScroll = function() {
      if (window.removeEventListener)      {
          window.removeEventListener('DOMMouseScroll', this.preventDefault, false);
      }
      window.onmousewheel = document.onmousewheel = null;
      window.onwheel = null;
      window.ontouchmove = null;
      document.onkeydown = null;
  };

  this.disableTabNavUnderOverlay = function(disableSelectors) {
    $(disableSelectors).find('a, input, textarea, button, [tabindex=0]').each(function() {
      $('.js-page-container, .js-page-footer').attr('aria-hidden','true');
      var $t = $(this);
      if ($t.attr('tabindex')) {
        $t.attr('data-tabindex', $t.attr('tabindex'));
        $t.attr('tabindex', '-1');
      }			else			{
				$t.attr('tabindex', '-1');
			}
    });
  };

  this.enableTabNavOnOverlayClose = function(disableSelectors) {

    $('.js-page-container, .js-page-footer').removeAttr('aria-hidden');

		$(disableSelectors).find('a, input, textarea, button').removeAttr('tabindex');

    $(disableSelectors).find('[data-tabindex]').each(function() {
      var $t = $(this);
      $t.attr('tabindex', $t.data('tabindex'));
			$t.removeAttr('data-tabindex');
    });
  };

  var keys = {37: 1, 38: 1, 39: 1, 40: 1};

  this.preventDefault = function(e) {
    e = e || window.event;
    if (e.preventDefault)
        e.preventDefault();
    e.returnValue = false;
  };

  this.preventDefaultForScrollKeys = function(e) {
    e = e || window.event;
    if (keys[e.keyCode]) {
        e.preventDefault();
        return false;
    }
  };

  this.lockScreen = function() {
    this.vars.currentScroll = window.pageYOffset;

    $('.js-page').css({'position' : 'fixed', 'top' : -(this.vars.currentScroll)+'px', 'width' : '100%','overfow' : 'hidden'});
  }

  this.unLockScreen = function() {

    $('.js-page').removeAttr('style');

    $('html, body').animate({
      scrollTop: this.vars.currentScroll
    }, 0);
  }

}();

jQuery.fn.reverse = [].reverse;

$(function() {
  app.init();
  app.replaceSVG();
});



function recaptchaValid(response) {   
    $('.js-form').each(function() {
    	$(this).trigger({
			type: 'recaptchaResponseValid',
			response: response,
    	});
    });
}

function recaptchaExpired(response) {
    $('.js-form').each(function() {
    	$(this).trigger({
			type: 'recaptchaResponseExpired',
			response: response,
    	});
    });
}

var recaptchaOnload = function() {
    app.vars.recaptchaScriptLoaded = true;
    recaptchaRender();
};

function recaptchaRender($element) {
    if (app.vars.recaptchaScriptLoaded) {
        if ($('#g-recaptcha').length) {
            grecaptcha.render(
                'g-recaptcha', {
                    'sitekey': '6LflUQgUAAAAAHIZoirMRstdthZYex6JserpvGdU', 
                    'callback': recaptchaValid,
                    'expired-callback': recaptchaExpired,
                }
            );
        }
    }
}

function page() {
  this.$page            = $(this.classes.page);
  this.$header          = $(this.classes.header);
  this.$pageContainer   = $(this.classes.pageContainer);
  this.$footer          = $(this.classes.footer);
  this.basePageUrl      = this.getBasePageUrl();
  self.pageCall         = undefined;
  self.currentAnimation = undefined;
  self.callType         = undefined;

  this.init();
}

page.prototype = {
  constructor: page,

  settings:{
    duration: app.settings.duration * 2.5,
    movement: 50,
    animation: 'top',
  },

  classes: {
    page          : '.js-page',
    header        : '.js-header',
    pageContainer : '.js-page-container',
    footer        : '.js-page-footer',
  },

  names: {
    isAbsolute: 'is-absolute',
  },

  init: function() {
    this.getBasePageUrl();
    this.addListeners();
    this.checkIfSearchPage();
    //this.checkForPDP()
  },

  addListeners: function() {
    // $('body').on('click', 'a[target="_parent"]', {self: this}, this.linkClickHandler);
    $('body').on('click', '.skip-link', {self: this}, this.skipLinkClickHandler);
    $(window).on('statechange', {self: this}, this.stateChangeHandler);
  },

  linkClickHandler: function(event) {
      event.preventDefault();
      var self = event.data.self;
      var $link = $(this);
      var animation = self.settings.animation;
      var linkAnimation = $link.data('page-animation');
      if (linkAnimation !== undefined && linkAnimation !== '') {
        animation = linkAnimation;
      }

      var url = $link.attr('href');
      var pageTitle = $link.attr('title');

      if (window.location.href == url || window.location.href == url + '/')      {
        $('html, body').animate({ scrollTop: 0 }, 0);
      }      else      {
        self.goToPageUrl(url, animation, pageTitle);
      }
  },


  skipLinkClickHandler: function(event) {
      event.preventDefault();
      var self = event.data.self;
      var $skiplink = $(this);
      $skiplink.blur();
      switch ($skiplink.attr('href')) {
        case '#top' :
          $('html, body').animate({ scrollTop:0}, 0);
          $('#top').focus();
          break;
        case '#main-content' :
          $('html, body').animate({ scrollTop: $('.js-page-container').position().top - $('.js-header-main').height() }, 0);
          $('#main-content').focus();
          break;
        case '#search' :
          $('.js-search-trigger').trigger('click');
          break;
        case '#detailHeader' :
          $('.js-detailHeader a:first').focus();
          break;
        case '#image-gallery' :
          $skiplink.parents('.module').find('.imageGallery__item').trigger('click');
          break;
      }
  },

  stateChangeHandler: function(event) {
    var self = event.data.self;
    var currentState = History.getState();
    var url = currentState['url'];

    if (currentState.data.state == 'page' || self.callType == 'page') {
      var animation;
      if (currentState.data.animation != undefined) {
        self.currentAnimation = currentState.data.animation;
      } else {
        self.currentAnimation = self.settings.animation;
      }
      self.openPage(url);

      self.checkIfSearchPage();
    }

  },





  ///////
  // Main

  openPage: function(url) {
    var self = this;

    // show preloader
    app.objects.preloader.showPreloader(self.$pageContainer.parent());
    self.$pageContainer.velocity({
      opacity: 0.6,
    }, {
      duration: self.settings.duration / 4,
      complete: function() {
        self.pageAjaxCall(url);
      },
    });
    self.$footer.velocity({
      opacity: 0.2,
    }, {
      duration: self.settings.duration / 4,
    });

  },


  pageAjaxCall: function(url) {
    var self = this;

    if (self.pageCall != undefined) {
      self.pageCall.abort();
    }
    self.pageCall = $.ajax({
      url: url,
      method: 'POST',
      data: {'ajaxPageCall': true},
    })
    .done(function(msg) {
      self.pageContentLoaded(msg);
    });
  },

  pageContentLoaded: function(msg) {
    var self = this;

    var $msg = $(msg);

    var $msgMeta = $msg.find('.js-page-meta');
    var $msgHeader = $msg.find('.js-header');
    var $msgMobileMenu = $msg.find('.js-mobileMenu');
    var $msgPageContainer = $msg.find('.js-page-container');
    var $msgFooterSkipLinks = $msg.find('.js-footer-skip-links');

    var pageMetaDesc = $msgMeta.data('description');
    var pageMetaKeywords = $msgMeta.data('keywords');
    var pageMetaShareImg = $msgMeta.data('share-img');
    $('head meta[name=description]').attr('content', pageMetaDesc);
    $('head meta[name=keywords]').attr('content', pageMetaKeywords);
    $('head meta[property="og:image"]').attr('content', pageMetaShareImg);
    $('head meta[property="og:description"]').attr('content', pageMetaDesc);

    $msgMeta.remove();

    self.$page.find('.js-overlay').remove();

    var oldContainerHeight = this.$pageContainer.outerHeight();

    $msgPageContainer.css({
      height: oldContainerHeight,
    });

    this.removeGlobalListeners();

    //app.objects.initModules.initLocal($msgPageContainer);
    app.objects.preloader.hidePreloader(self.$pageContainer.parent());
    window.clearInterval(app.vars.sliderInterval);

    var translateYOld = 0;
    var translateXOld = 0;
    var translateYNew = 0;
    var translateXNew = 0;
    switch (self.currentAnimation) {
      case 'top':
      translateYOld = self.settings.movement + 'px';
      translateYNew = '-' + self.settings.movement + 'px';
      break;
      case 'right':
      translateXOld = '-' + self.settings.movement + 'px';
      translateXNew = self.settings.movement + 'px';
      break;
      case 'left':
      translateXOld = self.settings.movement + 'px';
      translateXNew = '-' + self.settings.movement + 'px';
      break;
    }

    self.$pageContainer.velocity({
      translateY: translateYOld,
      translateX: translateXOld,
      opacity: 0,
    }, {
      easing: app.settings.easingIn,
      duration: self.settings.duration / 2,
      complete: function() {
        $msgPageContainer.css('height', 'auto');
        self.$pageContainer.after($msgPageContainer);
        self.$footer.css('opacity', 0);
        self.$pageContainer.remove();
        self.$pageContainer = $msgPageContainer;

        $('html, body').animate({ scrollTop: 0 }, self.settings.duration);

        if (window.location.href.indexOf('?search-phrase') < 0) {
          self.closeSearch();
        }
      },
    });


    $msgPageContainer.velocity({
      opacity: 1,
      position: 'relative',
      top: ($(window).width() > 960) ? $('.js-header-main').height() + $('.js-header-fixed-trigger').height() : 0,
    }, {
      easing: app.settings.easing,
      duration: 2 * self.settings.duration,
      delay: self.settings.duration / 2,
      complete: function() {
        $msgPageContainer.removeClass(app.names.isHidden).removeAttr('style');

        $(window).off('scroll');
        self.$page.off();
        $('.js-search-form').find('form').off();
        self.$footer.find('.js-ga-event-trigger').off();

        self.$header.html($msgHeader.html());
        self.$footer.find('.js-footer-skip-links').html($msgFooterSkipLinks);

        self.$footer.velocity({
          opacity: 1,
        }, {
          duration: self.settings.duration / 2,
        });

        setTimeout(function() {
          $(document).trigger('load');
          $(window).trigger('resize');

          $('.js-mobileMenu').html($msgMobileMenu.html());
          $('.js-mobileMenu-trigger').off();

          app.enableScroll();

          app.objects.initModules.initLocal(self.$page);

          $('#top').focus();
          jQuery.scrollDepth.reset();
        }, 100);
      },
    });

  },

  removeGlobalListeners: function() {
    // remove all previous recaptchas
    $('#g-recaptcha').remove();
  },

  closeSearch: function() {
    $('.js-search').removeClass('is-active').removeClass('is-animating');
    $('.js-header').removeClass('is-active-header');
    // $('.js-search').each(function() {
    //   $(this).trigger({
    //     type: 'toggleSearch',
    //   });
    // });
  },


  //////////
  // Helpers

  getBasePageUrl: function() {
    var currentUrl = window.location.href;
    var basecurrentUrl = currentUrl.split('?');
    return basecurrentUrl[0];
  },

  goToPageUrl: function(url, animation, pageTitle) {
    var newPageTitle = pageTitle;

    animation = animation || this.settings.animation;
    var anchor = url.split('#')[1];
    url = url.split('#')[0];
    if (anchor == undefined) anchor = false;
    this.callType = 'page';
    History.pushState({state: 'page', anchor: anchor, animation: animation}, newPageTitle, url);

    $('head meta[property="og:title"]').attr('content', newPageTitle);
    $('head meta[property="og:url"]').attr('content', url);

    var ga_url = url.replace('http://' + window.location.hostname, '');
    ga_url = ga_url.replace('https://' + window.location.hostname, '');
    if (ga_url == '') ga_url = '/';
    if (window['ga'] !== undefined) {
      ga('set', 'page', ga_url);
      ga('send', 'pageview');
    }

  },

  goBack: function() {
    History.back();
  },

  checkIfSearchPage: function() {

    var self = this;
    setTimeout(function() {

      if (getUrlParameter('search-phrase')) {
        $('.js-search').addClass('is-active').addClass('is-animating');
        $('.js-header').addClass('is-active-header');
        //self.closeSearch();
        $('.js-search-input').val(getUrlParameter('search-phrase'));
        if (getUrlParameter('search-products') == 'true') $('input[name=filter-products]').attr('checked','checked');
        if (getUrlParameter('search-stories-recipes') == 'true') $('input[name=filter-recipe-story]').attr('checked','checked');
        $('.search__button').trigger('click');
      }

    }, 500);

  },



//checkForPDP: function() {
//  var body = $('body');
//  var dataLayer = window.dataLayer || [];

//  var events = {
//    'is-pdpc': {
//      'event_name': 'view_product_category'
//    },
//    'is-pdp': {
//      'event_name': 'view_product'
//    },
//    'is-stories': {
//      'event_name': 'see_stories_and_recipes'
//    }
//  };

//  function pushEvent(event) {
//    setTimeout(function() {
//      dataLayer.push({
//        'event': 'ga4-event',
//        'event_name': event.event_name,
//        'parameter_name': '',
//        'parameter_value': ''
//      });
//      console.log(dataLayer)
//    }, 500);
//  }

//  Object.keys(events).forEach(function(className) {
//    if (body.hasClass(className)) {
//      pushEvent(events[className]);
//    }
//  });
//}

};

function preloader() {}

preloader.prototype = {

  states: {
    hasPreloader: 'has-preloader',
  },

  showPreloader: function($element, position, type, color) {
    var self = this;

    if ($element.children('.preloader').length) return false;

    $element.addClass(self.states.hasPreloader);

    var typeClass = (type ? 'preloader--' + type : '');
    var colorClass = (color ? 'preloader--' + color : '');


    var $preloader = $('<div class="preloader  ' + typeClass + '  ' + colorClass + '"><div class="preloader__inner"></div></div>');
    if (position == 'prepend') {
     $element.prepend($preloader);
   } else {
     $element.append($preloader);
   }

 },

 hidePreloader: function($element) {
  var self = this;
  var $preloader = $element.find('.preloader');
  $element.removeClass(self.states.hasPreloader);
  if ($preloader.length) {
    $preloader.addClass(app.names.isHidden);
    setTimeout(function() {
      $preloader.remove();
    }, app.settings.duration);
  }
},
};

function slider($el) {
  this.$el = $el;

  // elements
  this.$view       = this.$el.find(this.classes.view);
  this.$pagination = this.$el.find(this.classes.pagination);
  this.$items      = this.$el.find(this.classes.items);

  this.$overlay    = $(this.classes.overlay);
  this.$search     = $(this.classes.search);

  // init
  this.init();
}

slider.prototype = {
  constructor: slider,

  settings: {
    navigationHeight: null,
    height: null,
    parallaxOffset: 90,
    isAnimating: false,
    index: 0,
    count: 0,
    autoplay: true,
    autoplaySpeed: 5000,
  },

  classes: {
    view             : '.js-slider-view',
    items            : '.js-slider-item',
    itemWrapper      : '.js-slider-item-wrapper',
    pagination       : '.js-slider-pagination',
    paginationBullet : '.js-slider-pagination-bullet',
    tooltip          : '.js-tooltip',
    feature          : '.js-slider-feature',
    features         : '.js-slider-features',
    overlay          : '.js-overlay',
    search           : '.js-search',
  },

  states: {
    active      : 'is-active',
    visible     : 'is-visible',
    animating   : 'is-animating',
    autoplaying : true,
  },

  init: function() {
    this.addListener();
    this.initSlider();
  },

  addListener: function() {
    this.$pagination.on('click', this.classes.paginationBullet, {self: this}, this.paginationBulletClickHandler);
    this.$pagination.on('keypress',  this.classes.paginationBullet, {self: this}, this.triggerPagingKeyPressedHandler);
    this.$view.on('mouseenter', {self: this}, this.mouseEnterHandler);
    this.$view.on('focus', 'a', {self:this}, this.mouseEnterHandler);
    this.$view.on('mouseleave', {self: this}, this.mouseLeaveHandler);
  },

  triggerPagingKeyPressedHandler :function(event) {
    var keycode = (event.keyCode ? event.keyCode : event.which);
    if (keycode == 13) {
      $(this).trigger('click');
    }
    event.stopPropagation();
  },

  mouseEnterHandler: function(event) {

    var self = event.data.self;
    self.settings.autoplay = false;
    window.clearTimeout(app.vars.sliderInterval);
  },

  mouseLeaveHandler: function(event) {
    var self = event.data.self;

    if (self.$items.length > 1) {
      self.settings.autoplay = true;
      app.vars.sliderInterval = setInterval(function() {

        if (self.settings.autoplay) {
          self.animateTo(self.settings.index + 1);
        }

      }, self.settings.autoplaySpeed);
    }

  },

  paginationBulletClickHandler: function(event) {
    $('#slider-top').focus();
    var self = event.data.self;
    event.preventDefault();
    self.settings.autoplay = false;
    self.animateTo($(this).index());
  },

  initSlider: function() {
    this.settings.index = 0;
    var self = this;
    this.calculateHeight();
    this.setZIndex();
    this.setActiveItem();
    this.animateFeatureIn(self.settings.index);
    this.animateTooltipsIn(self.settings.index);
    this.fittext();

    if (this.$items.length > 1) {

      this.createPagination();

      app.vars.sliderInterval = setInterval(function() {

        if (self.settings.autoplay) {
          self.animateTo(self.settings.index + 1);
        }

      }, this.settings.autoplaySpeed);
    }

  },

  fittext: function() {
    this.$items.each(function(index) {
      $(this).find('.slider__item__title h2').fitText(0.93, { minFontSize: '40px', maxFontSize: '80px' });
      $(this).find('.slider__item__description').fitText(2.7, { minFontSize: '18px', maxFontSize: '22px' });
    });
  },

  setActiveItem: function(item) {
    this.$items.removeClass(this.states.active).attr('aria-hidden', 'true');
    if (typeof item === 'undefined') {
      this.$items.first().addClass(this.states.active).removeAttr('aria-hidden');
    } else {
      item.addClass(this.states.active).removeAttr('aria-hidden');
    }
  },

  calculateHeight: function() {
    this.settings.navigationHeight = $('.header').height();
    this.settings.height = $(window).height() - this.settings.navigationHeight - 20;
  },

  setZIndex: function() {
    this.$items.each(function(index) {
      $(this).css('z-index', (index == 0 ? 3 : 1));
    });
  },

  createPagination: function() {
    var self = this;
    this.$items.each(function(index) {
      self.$pagination.find('ul').append('<li class="js-slider-pagination-bullet' + (index == 0 ? ' ' + self.states.active + '' : '') + '" tabindex="0"><span role="button" aria-label="Weiter zum Folie ' + index + '"></span></li>');
    });

    this.settings.count = this.$items.length;
  },

  animateTooltipsIn: function(index) {
    var self = this;
    var $tooltips = this.$items.eq(index).find(this.classes.tooltip);

    $tooltips.each(function(index) {
      var that = $(this);

      setTimeout(function() {
        setTimeout(function() {
          that.addClass(self.states.visible);
        }, 80 * index);
      }, 250);

    });
  },

  animateTooltipsOut: function(index) {
    var self = this;
    var $tooltips = this.$items.eq(index).find(this.classes.tooltip);

    $tooltips.each(function(index) {
      $(this).removeClass(self.states.visible);
    });
  },

  animateTo: function(index) {
    var self = this;

    if (this.settings.isAnimating || index == self.settings.index) {
      return;
    }

    var startFromBegin = (index > this.settings.count - 1 ? true : false);
    var leftOrRight = (self.settings.index < index ? true : false);
    var direction = {};

    if (startFromBegin) {
      index = 0;
      leftOrRight = true;
    }

    if (leftOrRight) {
      direction = {
        nextLeft: '100%',
        nextWrapperLeft: '-',
        activeLeft: '-100%',
        activeLeftAfter: 0,
        activeWrapperLeft: '',
      };
    } else {
      direction = {
        nextLeft: '-100%',
        nextWrapperLeft: '',
        activeLeft: '100%',
        activeLeftAfter: '100%',
        activeWrapperLeft: '-',
      };
    }

    this.settings.isAnimating = true;

    var $nextItem             = this.$items.eq(index);
    var $nextItemWrapper      = $nextItem.find(this.classes.itemWrapper);
    var $activeItem           = this.$view.find('> .' + this.states.active);
    var $activeItemWrapper    = $activeItem.find(this.classes.itemWrapper);

    this.manageTabIndexes($activeItem, $nextItem, index);

    $nextItem
    .css('z-index', 3)
    .css('left', direction.nextLeft);

    $nextItemWrapper
    .css('left', direction.nextWrapperLeft  + self.settings.parallaxOffset + '%');

    $activeItem
    .css('z-index', 2);


    $activeItem.velocity({
      left: direction.activeLeft,
    }, {
      easing: app.settings.easing,
      duration: app.settings.duration * 4,
      complete: function() {

        $activeItem
        .css('z-index', 1)
        .css('left', direction.activeLeftAfter)
        .removeClass(self.states.active)
        .attr('aria-hidden', 'true');

        $nextItem.addClass(self.states.active).removeAttr('aria-hidden');
        self.settings.isAnimating = false;

      },
    });


    $activeItemWrapper.velocity({
      left: direction.activeWrapperLeft + self.settings.parallaxOffset + '%',
    }, {
      easing: app.settings.easing,
      duration: app.settings.duration * 4,
    });


    $nextItem.velocity({
      left: '0%',
      complete: function() {
        setTimeout(function() {
          self.animateTooltipsOut(index - 1);
          self.animateTooltipsIn(index);
        }, app.settings.duration * 2);
      },
    }, {
      easing: app.settings.easing,
      duration: app.settings.duration * 4,
    });


    $nextItemWrapper.velocity({
      left: '0%',
    }, {
      easing: app.settings.easing,
      duration: app.settings.duration * 4,
    });

    self.$pagination.find('ul li')
    .removeClass(self.states.active)
    .eq(index).addClass(self.states.active);

    self.animateFeatureOut(self.settings.index);
    self.animateFeatureIn(index);

    self.settings.index = index;

  },

  animateFeatureIn: function(index) {

    var $feature = this.$el.find(this.classes.feature + '[data-id="' + (index + 1) + '"]');
    var $featureImage = this.$el.find(this.classes.feature + '[data-id="' + (index + 1) + '"] .slider__feature__image');

    if ($feature.length) {
      $feature
      .css('margin-left', '-100%')
      .css('display', 'block')
      .addClass(this.states.visible)
      .delay(500)
      .addClass(this.states.animating)
      .velocity({
        marginLeft: '0',
        opacity: 1,
        scale: 1,
      }, {
        easing: app.settings.easing,
        duration: app.settings.duration * 4,
      });

      $featureImage.delay(500).velocity({
        rotateZ: '-10deg',
      }, {
        easing: 'easeInOutCubic',
        duration: app.settings.duration * 4,
      });

    }

  },

  animateFeatureOut: function(index) {
    var self = this;
    var $feature = this.$el.find(this.classes.feature + '[data-id="' + (index + 1) + '"]');
    var $featureImage = this.$el.find(this.classes.feature + '[data-id="' + (index + 1) + '"] .slider__feature__image');

    if ($feature.length) {
      $feature.velocity('reverse');

      $featureImage.velocity('reverse');

    }

  },
  manageTabIndexes: function($activeItem, $nextItem, index) {
    if (!this.$overlay.hasClass('is-visible') && !this.$search.hasClass('is-active'))    {
      $nextItem.find('a').removeAttr('tabindex');

      $nextItem.find('[data-tooltiptabindex]').each(function() {
        $t = $(this);
        $t.attr('tabindex', $t.data('tooltiptabindex'));
      });

      $activeItem.find('a').attr('tabindex', '-1');

      var $featureActive = this.$el.find(this.classes.feature + '[data-id="' + (index) + '"]');
      $featureActive.find('a').attr('tabindex', '-1');

      var $featureNext = this.$el.find(this.classes.feature + '[data-id="' + (index + 1) + '"]');
      $featureNext.find('a').removeAttr('tabindex');

      $featureNext.find('[data-tooltiptabindex]').each(function() {
        $t = $(this);
        $t.attr('tabindex', $t.data('tooltiptabindex'));
      });
    }
  },

};

function sliderMobile($el) {
	this.$el = $el;

	// elements
	this.$button = this.$el.find(this.classes.button);
	this.$swiperContainer = this.$el.find(this.classes.swiperContainer);
	this.$swiperPagination = this.$el.find(this.classes.swiperPagination);

	this.$swiper = '';
	this.isInitialSlideChange = true;
	// init
	this.init();
}

sliderMobile.prototype = {
	constructor: sliderMobile,

	classes: {
		button: '.js-sliderMobile-button',
		swiperContainer: '.js-sliderMobile-container',
		swiperPagination: '.js-sliderMobile-pagination',
	},

	init: function() {
		this.addListener();
		this.initSlider();
	},

	initSlider: function() {
		var self = this;

		self.$swiper = new Swiper(self.$swiperContainer, {
			pagination: self.$swiperPagination,
			paginationClickable: true,
			parallax: true,
			loop: true,
			a11y: true,
			firstSlideMessage: 'Dies ist das erste Folie',
			lastSlideMessage: 'Dies ist das letzte Folie',
			paginationBulletMessage: 'Weiter zum Folie {{index}}',

			onSlideChangeEnd : function() {

				if (!self.isInitialSlideChange) {
					$('#slider-mobile-top').focus();
				} else {
					self.isInitialSlideChange = false;
				}

				self.$swiperContainer.find('.swiper-slide a').attr('tabindex', '-1');
				self.$swiperContainer.find('.swiper-slide-active a').removeAttr('tabindex');
			},
		});
	},

	addListener: function() {
		this.$button.on('click', {self: this}, this.buttonClickHandler);
	},

	buttonClickHandler: function(event) {
		var self = event.data.self;
	},
};

function featured($el) {
  this.$el = $el;

  // elements
  this.$controls          = this.$el.find(this.classes.controls);
  this.$controlsItem      = this.$el.find(this.classes.controlsItem);
  this.$imageWrapper      = this.$el.find(this.classes.images);
  this.$images            = this.$el.find(this.classes.image);
  this.$contentItems      = this.$el.find(this.classes.contentItem);
  this.$contentWrapper    = this.$el.find(this.classes.contentWrapper);
  this.$touchScrollEls    = this.$el.find(this.classes.contentWrapper + ', ' + this.classes.images)

  // init
  this.init();
}

featured.prototype = {
  constructor: featured,

  classes: {
    controls: '.js-featured-controls',
    controlsItem: '.js-featured-controls-item',
    images: '.js-featured-images',
    image: '.js-featured-image',
    contentItem: '.js-featured-content-item',
    contentWrapper: '.js-featured-content',
  },

  settings: {
    isAnimating: false,
    index: 0,
    sliderBreak: 960,
    sliderEnabled: false,
  },

  states: {
    active: 'is-active',
    visible: 'is-visible',
  },

  checkSlider: function() {
    this.settings.sliderEnabled = window.innerWidth <= this.settings.sliderBreak;

    if (!this.settings.sliderEnabled) {
      this.$contentItems.css('transform', 'none')
    }
  },

  init: function() {
    var self = this;
    this.addListener();
    setTimeout(function() {
      // self.animateTo(0);
    }, 10)
    this.checkSlider()
  },


  touch: {
    active: false,
    initialX: 0,
  },
  $activeImage: null,
  $activeContent: null,
  $nextImage: null,
  $nextContent: null,
  $activeControl: null,
  $nextControl: null,

  getEeventPos: function(e) {
    var pos = {};
    if (e.pageX) {
      pos.x = e.pageX;
      pos.y = e.pageY;
    } else if (e.clientX) {
      pos.x = e.clientX;
      pos.y = e.clientY;
    } else if (e.originalEvent.touches && e.originalEvent.touches[0]) {
      pos.x = e.originalEvent.touches[0].pageX
      pos.y = e.originalEvent.touches[0].pageY
    }

    return pos;
  },

  addTouchEventListeners: function() {
    var self = this;
    var currentIndex;
    var nextIndex;

    this.$touchScrollEls.on('touchstart mousedown', function(e) {
      if (!self.settings.sliderEnabled) return;

      self.touch.active = true;
      self.touch.initialX = self.getEeventPos(e).x;
    })

    var dragFail = false;
    $(document)
      .on('touchmove mousemove', function(e) {
        if (!self.settings.sliderEnabled) return;

        if (self.touch.active) {
          var x = self.getEeventPos(e).x;
          var deltaX = x - self.touch.initialX;

          var setNext = deltaX > 0 ? self.settings.index - 1 : self.settings.index + 1;
          if (setNext < 0 || self.$contentItems.eq(setNext).length === 0) {
            dragFail = true
            return
          }

          dragFail = false;

          currentIndex = self.settings.index;
          nextIndex = setNext;
          // var prevIndex = nextIndex === 1 ? -1 : 1;

          if (nextIndex < 0 || nextIndex > (self.$contentItems.length - 1)) {
            deltaX = 0
          }

          self.$nextContent = self.$contentItems.eq(nextIndex);
          // var $prevContent = self.$contentItems.eq(prevIndex);
          self.$nextImage = self.$images.eq(nextIndex);
          self.$activeContent = self.$contentItems.eq(currentIndex);
          self.$activeImage = self.$images.eq(currentIndex);

          // if ($prevContent) {
          //   $prevContent.css({
          //     'transform': 'none',
          //     'opacity': '0',
          //   })
          // }
          if (self.$nextContent) {
            self.$nextContent.css({
              'transform': 'translateX(calc(' + (nextIndex > currentIndex ? '100%' : '-100%') + ' + ' + deltaX + 'px))',
              'display': 'block',
              'position': 'absolute',
              'top': '0',
            })
          } else {
            deltaX = 0;
          }

          if (self.$activeContent) {
            self.$activeContent.css('transform', 'translateX(' + deltaX + 'px)')
          }
        }
      })
      .on('touchend mouseup', function(e) {
        if (!self.settings.sliderEnabled || dragFail) return;

        if (self.touch.active) {
          self.touch.active = false;
          self.settings.isAnimating = true;

          self.$activeImage.removeClass(self.states.active).attr('aria-hidden', 'true');
          setTimeout(function() {
            self.$nextImage.addClass(self.states.active).attr('aria-hidden', 'false');
            setTimeout(function() {
              self.settings.isAnimating = false;
            }, 600);
          }, 400);

          if (nextIndex < 0 || nextIndex > (self.$contentItems.length - 1)) {
            return
          } else {
            self.$nextContent.addClass('animate-from-slider');
            self.$activeContent.addClass('animate-from-slider');
            self.settings.index = nextIndex
          }

          setTimeout(function() {
            if (self.$nextContent) {
              self.$nextContent.css({
                'transform': 'translateX(0%)',
              })
            }

            if (self.$activeContent) {
              self.$activeContent.css('transform', 'translateX(' + (nextIndex < currentIndex ? '100' : '-100') + '%)')
            }

            self.$contentWrapper.css('height', self.$nextContent.outerHeight());
          }, 1)

          setTimeout(function() {
            if (self.$nextContent) {
              self.$nextContent.css({
                'transform': 'none',
                'display': 'block',
                'position': 'static',
                'top': '0',
              })
            }

            if (self.$activeContent) {
              self.$activeContent.css({
                'transform': 'none',
                display: 'none',
              })
            }

            self.$nextContent.removeClass('animate-from-slider');
            self.$activeContent.removeClass('animate-from-slider');

            self.animateTo(self.settings.index);
          }, 300);
        }
      })


  },

  addListener: function() {
    var self = this;
    this.$controlsItem.on('click', {self: this}, this.controlsClickHandler);

    this.checkSlider();
    $(window).on('resize', function() {
      self.checkSlider();
    });

    this.$controlsItem.find('span').on('keypress', function(event){
      var keycode = (event.keyCode ? event.keyCode : event.which);
      if (keycode == 13) {
        $(this).parent().trigger('click');
      }
      event.stopPropagation();
    });

    this.addTouchEventListeners();
  },

  controlsClickHandler: function(event) {
    var self = event.data.self;
    event.preventDefault();

    self.animateTo($(this).index());
  },

  animateTo: function(index) {
    var self = this;

    var sliderAnimation = this.settings.sliderEnabled;

    var direction = this.settings.index > index ? -1 : 1;

    this.$activeImage        = this.$imageWrapper.find('.' + this.states.active);
    this.$activeContent      = this.$contentWrapper.find('.' + this.states.active);
    this.$nextImage          = this.$images.eq(index);
    this.$nextContent        = this.$contentItems.eq(index);
    this.$activeControl      = this.$controls.find('.' +  this.states.active);
    this.$nextControl        = this.$controlsItem.eq(index);

    this.$activeControl.removeClass(this.states.active).find('a').attr('aria-selected', 'false');
    this.$nextControl.addClass(this.states.active).find('a').attr('aria-selected', 'true');
    this.$activeImage.removeClass(this.states.active).attr('aria-hidden', 'true');

    if (this.settings.isAnimating || index === self.settings.index) {
      return;
    }


    this.$contentWrapper.css('height', this.$contentWrapper.outerHeight());

    this.$contentItems.removeAttr('style')

    this.settings.isAnimating = true;

    var animationDuration = app.settings.duration

    var animationParamsFrom = {
      opacity: 0,
    }
    var animationParamsTo = {
      opacity: 1,
    }

    if (sliderAnimation) {
      animationDuration = app.settings.duration * 2;
      animationParamsFrom = {
        translateX: (direction < 0 ? '100' : '-100') + '%',
      }
      animationParamsTo = {
        translateX: '0%',
      }

      this.$nextContent
        .css({
          opacity: 1,
        })
        .velocity({
          translateX: (direction > 0 ? '100' : '-100') + '%',
        }, {
          duration: 1,
        })
    }


    this.$activeContent.velocity(animationParamsFrom, {
      easing: app.settings.easing,
      duration: animationDuration * 0.5,
      complete: function() {

        self.$activeContent
          .removeClass(self.states.active)
          .removeClass(self.states.visible)
					.attr('aria-hidden', 'true')
					.find('a').attr('tabindex', '-1');

        self.$nextContent
          .addClass(self.states.visible)
          .addClass(self.states.active)
					.attr('aria-hidden', 'false')

          .velocity(animationParamsTo, {
            easing: app.settings.easing,
            duration: animationDuration * 0.5,
          })
					.find('a').removeAttr('tabindex');

        self.$contentWrapper.css('height', self.$nextContent.outerHeight() + 105);
        self.settings.index = index;

        setTimeout(function() {
          self.$contentWrapper.removeAttr('style');
        }, 0);

      },
    });

    setTimeout(function() {
        self.$nextImage.addClass(self.states.active).attr('aria-hidden', 'false');
        setTimeout(function() {
            self.settings.isAnimating = false;
        }, 600);
    }, 400);

  },
};

function tooltip($el) {
  this.$el    = $el;
  this.$trigger = $el.find(this.classes.trigger);
  this.$content = $el.find(this.classes.content);

  // init
  this.init();
}

tooltip.prototype = {
  constructor: tooltip,

  classes: {
    button: '.js-tooltip',
    content: '.js-tooltip-content',
    trigger: '.js-tooltip-trigger',
  },

  states: {
    active: 'is-active',
    visible: 'is-visible',
    trigerred: 'is-triggered',
  },

  init: function() {
    this.addListener();
    
    if (this.$el.hasClass(this.states.trigerred))    {
      this.$el.trigger('click');
    }
  },

  addListener: function() {
    this.$el.on('click', {self: this}, this.buttonClickHandler);
  },

  buttonClickHandler: function(event) {
    var $target =  $(event.target);
    if ($target.hasClass('icon--tooltip-minus') || $target.hasClass('icon--tooltip-plus'))    {
      event.preventDefault();
    }

    var self = event.data.self;

    self.hideTooltips(event);

    if (!self.$el.hasClass(self.states.active)) {
      event.preventDefault();
      self.showTooltip($(this));
    }

    if (self.$el.hasClass(self.states.active) && ($target.hasClass('icon--tooltip-minus') || $target.hasClass('tooltip__trigger__minus'))) {
      event.preventDefault();
      self.hideTooltip(self.$el, event);
    }

  },

  hideTooltips: function(event) {
    var self = this;
    $(this.classes.button).each(function() {

      if ($(this).hasClass(self.states.active) && !$(this).is(self.$el)) {
        self.hideTooltip($(this), event);
      }
    });
  },

  hideTooltip: function(that, event) {
    event.preventDefault();
    that
      .removeClass(this.states.active)
      .velocity('reverse');
    that.find(this.classes.trigger).velocity('reverse');
    that.find(this.classes.content).velocity('reverse');
    
    that.find('[data-tooltiptabindex]').each(function() {
      $t = $(this);
      $t.attr('tabindex', $t.data('tooltiptabindex'));
    });

    that.find('.js-tooltip-trigger-plus').trigger('focus');
  },

  showTooltip: function(that) {

    that.addClass(this.states.active);
    that.find('[tabindex=-1]').removeAttr('tabindex');
    that.find('.js-tooltip-trigger-plus').attr('tabindex', '-1');
    that.find('.js-tooltip-trigger-minus').focus();

    this.$el.velocity({
      borderRadius: 38,  
    }, {
      easing: app.settings.easing,
      duration: 0,
    });
  
    var left_padding = 60;
    var right_padding = 20;
    var max_width = 400;
  
    if (this.$content.hasClass('tooltip--with-image__content'))    {
      left_padding = 170;
      right_padding = 70;
      max_width = 500;
    }

    this.$content.velocity({
      paddingTop: 2,
      paddingRight: right_padding,
      paddingBottom: 2,
      paddingLeft: left_padding,
      maxWidth: max_width,
      maxHeight: 250,
      opacity: 1, 
    }, {
      easing: app.settings.easing,
      duration: app.settings.duration * 1.5,
    });

    this.$trigger.velocity({
     paddingTop: 0, //10,
     paddingRight: 0,
     paddingBottom: 0, //10,
     paddingLeft: 0,
         // height: 0
    }, {
     easing: app.settings.easing,
     duration: app.settings.duration * 1.5,
    });
  },

};

function mobileMenu($el) {
  this.$el = $el;

  // elements
  this.$button = this.$el.find(this.classes.button);
  this.$trigger = $('body').find(this.classes.trigger);
  this.$header = $('body').find(this.classes.header);

  // init
  this.init();
}

mobileMenu.prototype = {
  constructor: mobileMenu,

  classes: {
    button: '.js-mobileMenu-button',
    trigger: '.js-mobileMenu-trigger',
    header: '.js-header',
  },

  states: {
    active: 'is-active',
    activeHeader: 'is-active-menu',
  },

  settings: {
    isOpen: false,
  },

  vars: {
    disabledTabNavSelectors : '.js-overlay, .header__navigation,.js-page-container,.js-page-footer, .js-header-skip-links, .js-footer-skip-links',
  },

  init: function() {
    this.addListener();
  },

  addListener: function() {
    // this.$button.on('click', {self: this}, this.buttonClickHandler);
    this.$trigger.on('click', {self: this}, this.triggerClickHandler);
    this.$trigger.on('keypress', {self: this}, this.triggerKeyPressHandler);
  },

  triggerClickHandler: function(event) {
    event.preventDefault();
    var self = event.data.self;

    self.toggleMobileMenu();
  },

  triggerKeyPressHandler: function(event) {
    var keycode = (event.keyCode ? event.keyCode : event.which);
    if (keycode == 13) {
      self.toggleMobileMenu();
    }
    event.stopPropagation();
  },

  toggleMobileMenu: function() {
    var self = this;
    if (self.settings.isOpen) {
      app.enableTabNavOnOverlayClose(self.vars.disabledTabNavSelectors);
			self.$el.find('a').attr('tabindex', '-1');
    }    else    {
      app.disableTabNavUnderOverlay(self.vars.disabledTabNavSelectors);
			self.$el.find('a').removeAttr('tabindex');
    }

    if (self.settings.isOpen) {

      self.$el.removeClass(self.states.active).attr('aria-hidden', 'true');
      self.$trigger.removeClass(self.states.active);
      self.$header.removeClass(self.states.activeHeader);
      self.settings.isOpen = false;

      app.unLockScreen();
			// $('.js-page').css('-webkit-overflow-scrolling', 'touch');

    } else {

      app.lockScreen();

      if ($('.js-search').hasClass('is-active'))      {
        $('.js-search-close').trigger('click');
      }
      self.$el.addClass(self.states.active).removeAttr('aria-hidden');
      self.$trigger.addClass(self.states.active);
      self.$header.addClass(self.states.activeHeader);
      self.settings.isOpen = true;
			// $('.js-page').css('-webkit-overflow-scrolling', 'auto');
    }

  },

  buttonClickHandler: function(event) {
		event.preventDefault();
    var self = event.data.self;
    self.$trigger.trigger('click');
  },
};

function productCategories($el) {
  this.$el = $el;

  // elements
  this.$button = this.$el.find(this.classes.button);
  this.$slider = this.$el.find(this.classes.slider);
  this.$pagination = this.$el.find(this.classes.pagination);
  this.$swiper;

  // init
  this.init();
}

productCategories.prototype = {
  constructor: productCategories,

  classes: {
    button: '.js-productCategories-button',
    slider: '.js-productCategories-slider',
    pagination: '.js-producCategories-pagination',
  },

  init: function() {
    this.addListener();
    this.initSlider();
  },

  addListener: function() {
    //this.$button.on('click', {self: this}, this.buttonClickHandler);
  },

  initSlider: function() {
    var self = this;

    enquire.register('screen and (max-width:960px)', {
      
      
      match : function() {
        self.$swiper = new Swiper(self.$slider, {
                  direction: 'horizontal',
                  slidesPerView: 3,
                  spaceBetween: 12,
                  pagination: self.$pagination,
                  a11y: true,
                  firstSlideMessage: 'Dies ist das erste Produktkategorie',
                  lastSlideMessage: 'Dies ist das letzte Produktkategorie',
                  paginationBulletMessage: 'Weiter zum Produktkategorie {{index}}',
                  breakpoints: {
                    // when window width is <= 320px
                    560: {
                      slidesPerView: 2,
                    },
                  },
        });
        
        $('.productCategories__item a').on('focus', function() {
          self.$swiper.slideTo($(this).parents().eq(1).index());
        });
      },      
                                  
      unmatch : function() {},    
     
      setup : function() {},    

      deferSetup : true,
   
      destroy : function() {},
        
  });

  },

  // buttonClickHandler: function(event){
  //   var self = event.data.self;
  // },
};

function hero($el) {
  this.$el = $el;

  this.init();
}

hero.prototype = {
  constructor: hero,

  init: function() {
  	this.fittext();
  },

  fittext: function() {
	//this.$el.find(".hero__title h2").fitText(0.7, { minFontSize: '40px', maxFontSize: '80px' });
  },
 
};

function products($el) {
  this.$el = $el;

  // elements
  this.$button = this.$el.find(this.classes.button);
  this.$filterDropdown = this.$el.find(this.classes.filterDropdown);
  this.$filterRow = this.$el.find(this.classes.filterRow);
  this.$productList = this.$el.find(this.classes.productList);
  this.$filterItems = this.$el.find(this.classes.filterItems);
  this.$loadMoreContainer = this.$el.find(this.classes.loadMoreContainer);

  // init
  this.init();
}

products.prototype = {
  constructor: products,

  classes: {
    button: '.js-products-button',
    filterDropdown: '.js-products-filter-dropdown',
    filterRow: '.js-products-filter',
    productList: '.js-products-list',
    filterItems: '.js-products-filter-item',
    loadMoreContainer: '.js-products-load-more-container',
  },

  states: {
    active: 'is-active',
  },

  settings: {
    activeFilter: '',
    preventChange: false,
  },

  init: function() {
    this.addListener();
    this.initFilter();
    this.initActiveFilter();
    this.initMatchHeight();

    if (this.$el.data('subcategory')) {
    $self = this;
      this.$el.imagesLoaded(function() {
        if ($('#' + $self.$el.data('subcategory'))) {
          $('html, body').animate({ scrollTop: $('#' + $self.$el.data('subcategory')).position().top + 400 }, 200);
        }
      });
    }

    // this.setMeta();
  },

  initMatchHeight: function() {
    var self = this;

    if (Detectizr.browser.name == 'safari' && Detectizr.browser.major <= 8) {
      self.$productList.find('.products__item').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false,
      });
    }

  },

  initFilter: function() {
    var self = this;

    self.$filterDropdown.select2({
      templateSelection: self.formatFilterDropdown,
    	templateResult: self.formatFilterDropdown,
    	minimumResultsForSearch: Infinity,
    });
  },

  formatFilterDropdown: function(state) {
    var self = this;
  	return $('<span class="products__filter__dropdown__icon" style="background: url(' + $(state.element).attr('data-img') + ')"></span> ' + '<span class="products__filter__dropdown__text">' + state.text + '</span>');
  },

  addListener: function() {
    this.$filterItems.on('click change', {self: this}, this.filterClickHandler);
		this.$filterItems.on('keypress', {self: this}, this.filterKeyPressHandler);
  },

  filterClickHandler: function(event) {
    var self = event.data.self;
    event.preventDefault();
    self.setFilter($(this));
  },

  filterKeyPressHandler: function(event) {
    var keycode = (event.keyCode ? event.keyCode : event.which);
    if (keycode == 13) {
      $(this).trigger('click');
    }
  },

  initActiveFilter: function() {
    var self = this;
    self.settings.activeFilter = this.$filterItems.parent().find('.is-active').attr('data-filter');

    setTimeout(function() {
      self.$filterRow.find('.products__filter__item--hidden').removeClass('products__filter__item--hidden');
    }, 200);
  },

  setFilter: function(that) {
    var self = this;

    if (self.settings.preventChange) {
      self.settings.preventChange = false;
      return;
    }

    var newFilter;

    // check what type of filter the user clicked
    if (that.attr('data-filter')) {
      newFilter = that.attr('data-filter');
    } else {
      newFilter = that.find('option:selected').val();
    }

    // return if filter is already set
    if (self.settings.activeFilter == newFilter) {
      return;
    }

    self.settings.activeFilter = newFilter;

    self.$filterItems.removeClass(self.states.active).attr('aria-expanded', 'false');
    self.$filterItems.each(function() {
      if ($(this).attr('data-filter')) {
        if ($(this).attr('data-filter') == self.settings.activeFilter) {
          $(this).addClass(self.states.active).attr('aria-expanded', 'true');
        }
      }
    });

    self.settings.preventChange = true;
    self.$filterDropdown.val(self.settings.activeFilter).trigger('change');

    $('#producsFilterList').focus();

    self.updateProducts();
  },

  updateProducts: function() {
    var self = this;

    self.$productList.css('height', self.$productList.outerHeight());

    self.$loadMoreContainer.velocity({
      opacity: 0,
      translateY: '-20px',
    }, {
      easing: app.settings.easing,
      duration: app.settings.duration * 2,
      // request new data
      complete: function() {
        $.ajax({
          url: self.$productList.attr('data-api'),
          type: 'POST',
          cache: false,
          data: {
            category: self.settings.activeFilter,
          },
          dataType: 'json',
          success: function(data) {
            var html = data.html;

            // insert new data and animate in
            self.$loadMoreContainer
              .empty()
              .append($(html))
              .velocity({
                opacity: 1,
                translateY: '0px',
              }, {
                easing: app.settings.easing,
                duration: app.settings.duration * 2,
                // animate the height
                complete: function() {
                  self.$productList.velocity({
                    height:  self.$loadMoreContainer.outerHeight(),
                  }, {
                    easing: app.settings.easing,
                    duration: app.settings.duration * 2,
                    // remove temp styles
                    complete: function() {
                      self.$productList.removeAttr('style');
                    },
                  });
                },
              });

            // scroll to top of container
            $('html,body').animate({
              scrollTop: ($(window).width() < 960) ? self.$filterRow.offset().top - $('.js-mobile-header').outerHeight()-30 : self.$filterRow.offset().top - $('.js-header-wrapper').outerHeight(),  //- 360,
            }, 300);

						history.pushState({}, '', window.location.origin + '/produkte/uebersicht/' + self.settings.activeFilter);
            app.objects.initModules.initLocal(self.$loadMoreContainer);

            self.setMeta();
          },
          error: function() {
          },
        });
      },
    });

  },
  setMeta: function() {
    var $active = this.$el.find(this.classes.filterItems+'.is-active');
    var pageMetaDesc = $active.data('meta-desc');
    var pageMetaKeywords = $active.data('meta-keywords');
    var pageMetaShareImg = $active.data('share-img');
    var pageTitle = $active.data('event-label');
    $('head title').html(pageTitle);
    $('head meta[name=description]').attr('content', pageMetaDesc);
    $('head meta[name=keywords]').attr('content', pageMetaKeywords);
    $('head meta[property="og:image"]').attr('content', pageMetaShareImg);
    $('head meta[property="og:title"]').attr('content', pageTitle);
    $('head meta[property="og:description"]').attr('content', pageMetaDesc);
    $('head meta[property="og:url"]').attr('content', window.location.origin + '/produkte/uebersicht/' + this.settings.activeFilter + '/');

  }
};

function productNutritions($el) {
  this.$el = $el;

  // elements
  this.$kcalItems = this.$el.find(this.classes.kcal);

  // init
  this.init();
}

productNutritions.prototype = {
  constructor: productNutritions,

  classes: {
    kcal: '.productNutritions__table__cell--kcal',
  },

  init: function() {
    this.addListener();
    this.addStylingForTable();
  },

  addListener: function() {
    //this.$button.on('click', {self: this}, this.buttonClickHandler);
  },

  addStylingForTable: function() {
    var self = this;

    self.$kcalItems.each(function() {
      var text = $(this).html();
      $(this).html(text.replace('g', '<span>g</span>'));
    });
  
  },

};

function productSteps($el) {
  this.$el = $el;

  // elements
  this.$player = this.$el.find(this.classes.player);
  this.$thumbnail = this.$el.find(this.classes.thumbnail);
  this.$iframe = this.$el.find(this.classes.iframe);

  this.$youtubePlayer = '';

  // init
  this.init();
}

productSteps.prototype = {
  constructor: productSteps,

  classes: {
    player: '.js-productSteps-player',
    thumbnail: '.js-productSteps-thumbnail',
    iframe: '.js-productSteps-iframe',
  },

  states: {
    active: 'is-active',
    playing: 'is-playing',
  },

  settings: {
    status: 'ready',
  },

  init: function() {
    this.addListener();
    this.initMatchHeight();
  },

  initMatchHeight: function() {
    var self = this;

    if (Detectizr.browser.name == 'safari' && Detectizr.browser.major <= 8) {
      self.$el.find('.productSteps__item').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false,
      });
    }

  },

  addListener: function() {
    this.$thumbnail.on('click', {self: this}, this.thumbnailClickHandler);
  },

  onPlayerReady: function(event) {
    var self = this;

    // play the video
    event.target.playVideo();

    // hide the thumbnail
    self.$el.addClass(self.states.playing);

    setTimeout(function() {
      self.$thumbnail.css('display', 'none');
    }, 300);
   
  },

  thumbnailClickHandler: function(event) {
    var self = event.data.self;

    if (self.settings.status == 'ready') {
      
      self.$el.addClass(self.states.active);
      self.$youtubePlayer = new YT.Player(self.$iframe[0], {
      events: {
        'onReady': function(event) {
          self.onPlayerReady(event);
        },
      },
    });

    } else if (self.settings.status == 'active') {
      self.$el.removeClass(self.states.playing);
    }

  },
};

function moments($el) {
  this.$el = $el;

  // elements
  this.$page              = $(this.classes.page);
  this.$dropdownTriggers  = this.$el.find(this.classes.dropdownTrigger);
  this.$dropdownMenus     = this.$el.find(this.classes.dropdownMenu);
  this.$header            = this.$el.find(this.classes.header);
  this.$headerContent     = this.$el.find(this.classes.headerContent);
  this.$extendedMenus     = this.$el.find(this.classes.extendedMenus);
  this.$loadMoreContainer = this.$el.find(this.classes.loadMoreContainer);
  this.$loadMoreTrigger   = this.$el.find(this.classes.loadMoreTrigger);

  this.api                = this.$el.attr('data-api');
  this.url                = this.$el.attr('data-url');
  // init
  this.init();
}

moments.prototype = {
  constructor: moments,

  classes: {
    dropdownTrigger   : '.js-moments-dropdown-trigger',
    dropdownMenu      : '.js-moments-dropdown-item',
    header            : '.js-moments-header',
    headerContent     : '.js-moments-header-content',
    extendedMenus     : '.js-moments-extended',
    loadMoreContainer : '.js-moments-load-more-container',
    loadMoreTrigger   : '.js-moments-load-more-trigger',
    storyItem         : '.js-story-item',
    recipeItem        : '.js-recipe-item',
    tippItem          : '.js-tipp-item',
    page              : '.js-page',
  },

  states: {
    active          : 'is-active',
    activeHTML      : 'is-active-moments-dropdown',
    loadMoreHidden  : 'is-hidden',
    loadMoreLoading : 'is-loading',
    loadMoreLazy    : 'is-lazy-loaded',
  },

  settings: {
    data: {},
  },

  init: function() {
    this.addListener();

    if (window.location.pathname == '/stories-und-rezepte/') {
      history.pushState({}, '', window.location.origin + '/stories-und-rezepte/inspiration/');
    }

    this.settings.data = {};
    var self = this;
    this.$dropdownMenus.each(function() {

      if ($(this).attr('data-value')) {
        self.settings.data[$(this).attr('data-value')] = $(this).find('.' + self.states.active).find('a').attr('data-value');
      }

    });

    self.initMatchHeightStories();
    self.initMatchHeightTipps();
  },

  addListener: function() {
    this.$dropdownTriggers.on('click', {self: this}, this.dropdownHandler);
		this.$dropdownTriggers.on('keypress', {self: this}, this.dropdownKeyPressHandler);
    this.$dropdownMenus.on('click', 'ul li', {self: this}, this.dropdownMenuHandler);
    this.$dropdownMenus.on('blur', 'ul li a', {self: this}, this.dropdownBlurHandler);
    this.$dropdownMenus.on('keyup', 'ul li a', {self: this}, this.menuItemKeyUpHandler);
    $('body').on('click', {self: this}, this.bodyClickHandler);
    $('body').on('click', this.classes.loadMoreTrigger, {self: this}, this.loadMoreTriggerClickHandler);
    $(window).on('scroll',  {self: this}, this.loadMoreScrollTrigger);
  },

  bodyClickHandler: function(event) {
    var self = event.data.self;

    var target = $(event.target).closest(self.classes.headerContent);

    if (!target.length && $('html').hasClass(self.states.activeHTML)) {
        if ($(self.classes.dropdownMenu + '.' + self.states.active).length) {
            $('html').removeClass(self.states.activeHTML);
            self.hideDropdowns();
        }
    }

  },
  loadMoreScrollTrigger: function(event) {
    var self = event.data.self;
    if (self.$loadMoreContainer.find(self.classes.loadMoreTrigger).hasClass(self.states.loadMoreHidden))    {
      if (($(window).scrollTop() + $(window).height() - 250) >  self.$loadMoreContainer.find(self.classes.loadMoreTrigger).position().top)      {
        app.disableScroll();
        self.$loadMoreContainer.find(self.classes.loadMoreTrigger + ':not(.' + self.states.loadMoreLoading + ')').addClass(self.states.loadMoreLoading).trigger('click');
      }
    }
  },
  loadMoreTriggerClickHandler: function(event) {
    var self = event.data.self;
    var $trigger = $(this);

    event.preventDefault();

    self.settings.data['type'] = $trigger.attr('data-value');
    self.settings.data['loadMore'] = true;

    self.settings.data['loadedStories'] = self.getDisplayedItems(self.classes.storyItem);
    self.settings.data['loadedRecipes'] = self.getDisplayedItems(self.classes.recipeItem);
    self.settings.data['loadedArticlesCount'] = $(self.classes.storyItem + ', ' + self.classes.recipeItem + ', ' + self.classes.tippItem).length;
    self.settings.data['loadedTipps'] = self.getDisplayedItems(self.classes.tippItem);

    if (self.settings.data['type'] == 'recipies' || self.settings.data['type'] == 'inspiration') {
      $('.js-recipe-rating-item').off();
    }

    $.ajax({
      url: self.api,
      type: 'POST',
      cache: false,
      data: self.settings.data,
      dataType: 'json',
      success: function(data) {
        // alert('why do you scroll me to the top');
        var $html = $(data.html);
        $trigger.parent().remove();
        self.$loadMoreContainer.append($html);
        setTimeout(function() {
                             self.$loadMoreContainer.find('.' + self.states.loadMoreLazy).removeClass(self.states.loadMoreLazy);
                         }, 10);
        app.enableScroll();
        if (self.settings.data['type'] == 'recipies' || self.settings.data['type'] == 'inspiration') {
          $('.recipe__list').each(function(e) {
            app.objects.initModules.initLocal($(this));
          });
        }
        self.$loadMoreContainer.find('.js-ga-event-trigger').off();
        app.objects.initModules.initLocal(self.$loadMoreContainer);
        self.initMatchHeightStories();
        self.initMatchHeightTipps();
      },
      error: function() {

      },
    });

  },

  dropdownKeyPressHandler: function(event) {
    var keycode = (event.keyCode ? event.keyCode : event.which);
    if (keycode == 13) {
      $(this).trigger('click');
    }
    event.stopPropagation();
  },

  dropdownHandler: function(event) {
    var self = event.data.self;
    self.showDropdown($(this).attr('data-trigger-id'));
  },

  dropdownMenuHandler: function(event) {
    var self = event.data.self;
    event.preventDefault();
    self.updateDropdown($(this));
		$('#main-content').focus();
  },

  dropdownBlurHandler: function(event) {
    var self = event.data.self;
    event.preventDefault();

    if ($(this).parent().is(':last-child')) {
      $(this).parent().parent().find(':first-child').find('a').trigger('focus');
    }
  },

  menuItemKeyUpHandler: function(event) {
    var self = event.data.self;

    var keycode = (event.keyCode ? event.keyCode : event.which);
    if (keycode == 27) {
      self.hideDropdowns();
    }
    event.stopPropagation();
  },

  updateDropdown: function(element) {
    var self = this;
    var index = element.closest(self.classes.dropdownMenu).attr('data-item-id');
    var $that = self.$dropdownTriggers.filter('[data-trigger-id="' + index + '"]');

    $that.find('span').html(element.find('a').html());
    $that.attr('aria-activedescendant', $(element).attr('id'));



    // reset active classes
    element.siblings().removeClass(self.states.active).find('a').attr('aria-selected', 'false');

    // set active class
    element.addClass(self.states.active).find('a').attr('aria-selected', 'true');

    // hide all dropdowns
    self.hideDropdowns();

    // show the extended menus
    if (index == 1) {
      if (element.attr('data-extended') == 'true') {
        self.$extendedMenus
          .hide()
          .filter('[data-extended-area="' + element.attr('data-extended-trigger') + '"]')
          .css('display', 'inline');
      } else {
        self.$extendedMenus.hide();
      }

    }

    /**
     * Update the content
     */
    self.updateContent();

  },

  showDropdown: function(index) {
    var self = this;
    var $itemMenu     = self.$dropdownMenus.filter('[data-item-id="' + index + '"]');
    var $that         = self.$dropdownTriggers.filter('[data-trigger-id="' + index + '"]');

    /**
     * Hide all other dropdowns
     */

    self.hideDropdowns();

    $('html').addClass(self.states.activeHTML);

    /**
     * Animate it in
     */
    $itemMenu
      .css('display', 'inline')
      .css('min-width', $that.width() + 30)
      .css('left', $that.position().left)
      // .css('top', ($that.offset().top - self.$headerContent.offset().top) - ($itemMenu.outerHeight() / 2) + ($that.height() / 2) + 115)
      .css('top', -($that.parent().parent().offset().top - self.$headerContent.parent().offset().top) + 60)
      .addClass(self.states.active)
      .attr('aria-hidden', 'false');
			// .find('.js-moments-dropdown-item-focus').focus();

    $itemMenu.velocity({
      opacity: '1',
      top: '-=30px',
    }, {
      easing: app.settings.easing * 2,
      duration: app.settings.duration,
    });

    // setTimeout(function(){
    //   $itemMenu.find('.js-moments-dropdown-item-focus').focus();
    // }, app.settings.duration);
  },

  hideDropdowns: function() {
    var self = this;

    self.$dropdownMenus.each(function() {
      $(this)
        .css('display', 'none')
        .removeClass(self.states.active)
        .removeAttr('style')
        .attr('aria-hidden', 'true')
    });

    $('html').removeClass('is-active-moments-dropdown');

  },

  updateContent: function() {
    var self = this;

    self.settings.data = {};

    self.$dropdownMenus.each(function() {

      if ($(this).attr('data-value')) {
        self.settings.data[$(this).attr('data-value')] = $(this).find('.' + self.states.active).find('a').attr('data-value');
      }

    });

    if (self.settings.data['type'] == 'recipies') {
      $('.js-recipe-rating').off();
    }

    self.$loadMoreContainer.css('height', self.$loadMoreContainer.outerHeight());
    self.$loadMoreContainer.velocity({
      opacity: 0,
      translateY: '-20px',
    }, {
      easing: app.settings.easing,
      duration: app.settings.duration * 2,
      // request new data

      complete: function() {
        $.ajax({
          url: self.api,
          type: 'POST',
          cache: false,
          data: self.settings.data,
          dataType: 'json',
          success: function(data) {
            var html = data.html;
            var historyState = '';

            if (self.settings.data.type == 'stories') historyState = '/stories/' + self.settings.data['stories-category'];
            if (self.settings.data.type == 'inspiration') historyState = '/inspiration';
            if (self.settings.data.type == 'recipies') historyState = '/rezepte/' + self.settings.data['recipies-category'] + '/' + self.settings.data['recipies-duration'];
            if (self.settings.data.type == 'tipps-zum-verfeinern') historyState = '/tipps-zum-verfeinern/' + self.settings.data['tipps-category'];

            history.pushState({}, '', window.location.origin + '/' + self.url + historyState + '/');

            // insert new data and animate in
            self.$loadMoreContainer
              .empty()
              .append($(html))
              .velocity({
                opacity: 1,
                translateY: '0px',
              }, {
                easing: app.settings.easing,
                duration: app.settings.duration * 2,
                // animate the height
                complete: function() {
                  self.$loadMoreContainer.velocity({
                    height:  self.$loadMoreContainer.outerHeight(),
                  }, {
                    easing: app.settings.easing,
                    duration: app.settings.duration * 2,
                    // remove temp styles
                    complete: function() {
                      self.$loadMoreContainer.removeAttr('style');

                      if (self.settings.data['type'] == 'recipies') {
                        app.objects.initModules.initLocal($('.recipe__list'));
                      }
                    },
                  });
                },
              });
            app.objects.initModules.initLocal(self.$loadMoreContainer);
            self.initMatchHeightStories();
            self.initMatchHeightTipps();
          },
          error: function() {
          },
        });
      },
    });


  },
  initMatchHeightStories: function() {
    var self = this;
    this.$el.find('.story__list.new').imagesLoaded(function() {
      self.$el.find('.story__list.new .story__item').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false,
      });
      self.$el.find('.story__list.new').removeClass('new');
    });
  },

  initMatchHeightTipps: function() {
    var self = this;
    this.$el.find('.tipps__list.new').imagesLoaded(function() {
      self.$el.find('.tipps__list.new .tipps__item').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false,
      });
      self.$el.find('.tipps__list.new').removeClass('new');
    });
  },
  getDisplayedItems: function(selector) {
    var getDisplayedItems = [];

    $(selector).each(function() {
      getDisplayedItems.push($(this).data('post-id'));
    });

    return getDisplayedItems;
  },

};

function recipeHeader($el) {
  this.$el = $el;

  // elements
  this.$player = this.$el.find(this.classes.player);
  this.$thumbnail = this.$el.find(this.classes.thumbnail);
  this.$iframe = this.$el.find(this.classes.iframe);

  this.$youtubePlayer = '';

  // init
  this.init();
}

recipeHeader.prototype = {
  constructor: recipeHeader,

  classes: {
    player: '.js-recipeHeader-player',
    thumbnail: '.js-recipeHeader-thumbnail',
    iframe: '.js-recipeHeader-iframe',
  },

  states: {
  	active: 'is-active',
  	playing: 'is-playing',
  },

  settings: {
  	status: 'ready',
  },

  init: function() {
    this.addListener();
  },

  addListener: function() {
    this.$thumbnail.on('click', {self: this}, this.thumbnailClickHandler);
		this.$thumbnail.on('keypress', {self: this}, this.thumbnailKeyPressHandler);
  },

  onPlayerReady: function(event) {
  	var self = this;

  	// play the video
  	event.target.playVideo();

  	// hide the thumbnail
  	setTimeout(function() {
  		self.$el.addClass(self.states.playing);

	    setTimeout(function() {
	    	self.$thumbnail.css('display', 'none');
	    }, 300);
	    
  	}, 300);
   
  },
  thumbnailKeyPressHandler: function(event) {
		var keycode = (event.keyCode ? event.keyCode : event.which);
    if (keycode == 13) {
      $(this).trigger('click');
    }
    event.stopPropagation();
	},
  thumbnailClickHandler: function(event) {
    var self = event.data.self;
		var maxheight = $(window).height() - $('.js-header-main').height() - $('.js-header-fixed-trigger').height();
    if (self.settings.status == 'ready') {
    	
    	self.$el.addClass(self.states.active).css('max-height', maxheight + 'px');
			self.$iframe.removeAttr('tabindex').focus();
    	self.$youtubePlayer = new YT.Player(self.$iframe[0], {
			events: {
				'onReady': function(event) {
					self.onPlayerReady(event);
				},
				'onStateChange': function(event) {
					//video paused or ended
					if (event.data == YT.PlayerState.PAUSED || event.data == YT.PlayerState.ENDED) 					{
						self.$el.removeClass(self.states.playing).removeClass(self.states.active).removeAttr('style');
					}
					if (event.data == YT.PlayerState.ENDED) {
						self.$thumbnail.css('display', 'block');
						self.$iframe.attr('tabindex', '-1').blur();
					}					else if (event.data == YT.PlayerState.BUFFERING)					{
						self.$el.addClass(self.states.active);
					}					else if (event.data == YT.PlayerState.PLAYING)					{
						self.$el.addClass(self.states.playing).addClass(self.states.active).css('max-height', maxheight + 'px'); ;
					}
				},
			},
		});

    } else if (self.settings.status == 'active') {
    	self.$el.removeClass(self.states.playing);
    }

  },
};

function imageSlider($el) {
  this.$el = $el;

  // elements
  this.$button = this.$el.find(this.classes.button);
  this.$swiperContainer = this.$el.find(this.classes.swiperContainer);
  this.$swiperPagination = this.$el.find(this.classes.swiperPagination);
  this.$swiperButtonNext = this.$el.find(this.classes.swiperButtonNext);
  this.$swiperButtonPrev = this.$el.find(this.classes.swiperButtonPrev);

  this.$swiper = '';

  // init
  this.init();
}

imageSlider.prototype = {
  constructor: imageSlider,

  classes: {
    button: '.js-imageSlider-button',
    swiperContainer: '.js-imageSlider-container',
    swiperPagination: '.js-imageSlider-pagination',
    swiperButtonPrev: '.js-imageSlider-button-prev',
    swiperButtonNext: '.js-imageSlider-button-next',
  },

  init: function() {
    this.addListener();
    var that = this;
    setTimeout(function() {
      that.initSlider();
    },200);
  },

  initSlider: function() {
    var self = this;

    self.$swiper = new Swiper(self.$swiperContainer, {
        pagination: self.$swiperPagination,
        slidesPerView: 'auto',
        paginationClickable: true,
        nextButton: self.$swiperButtonNext,
        prevButton: self.$swiperButtonPrev,
        spaceBetween: 20,
        a11y: true,
        prevSlideMessage: 'Vorheriges Bild',
        nextSlideMessage: 'Nächstes Bild',
        firstSlideMessage: 'Dies ist das erste Bild',
        lastSlideMessage: 'Dies ist das letzte Bild',
        paginationBulletMessage: 'Weiter zum Bild {{index}}',
    });

  },

  addListener: function() {
    this.$button.on('click', {self: this}, this.buttonClickHandler);
  },

  buttonClickHandler: function(event) {
    var self = event.data.self;
  },
};

var initPhotoSwipeFromDOM = function(gallerySelector) {
    // parse slide data (url, title, size ...) from DOM elements 
    // (children of gallerySelector)
    var parseThumbnailElements = function(el) {
      var thumbElements = $(el).find('figure'), //el.childNodes,
            numNodes = $(thumbElements).length,
            items = [],
            figureEl,
            linkEl,
            size,
            item;
        for (var i = 0; i < numNodes; i++) {

            figureEl = thumbElements[i]; // <figure> element

            // include only element nodes 
            if (figureEl.nodeType !== 1) {
                continue;
            }

            linkEl = figureEl.children[0]; // <a> element

            size = linkEl.getAttribute('data-size').split('x');

            // create slide object
            item = {
                src: linkEl.getAttribute('href'),
                w: parseInt(size[0], 10),
                h: parseInt(size[1], 10),
            };



            if (figureEl.children.length > 1) {
                // <figcaption> content
                item.title = figureEl.children[1].innerHTML; 
            }

            if (linkEl.children.length > 0) {
                // <img> thumbnail element, retrieving thumbnail url
                item.msrc = linkEl.children[0].getAttribute('src');
            } 
            item.el = figureEl; // save link to element for getThumbBoundsFn

            items.push(item);
        }
        return items;
    };

    // find nearest parent element
    var closest = function closest(el, fn) {
        return el && (fn(el) ? el : closest(el.parentNode, fn));
    };

    // triggers when user clicks on thumbnail
    var onThumbnailsClick = function(e) {

        e = e || window.event;
        e.preventDefault ? e.preventDefault() : e.returnValue = false;

        var eTarget = e.target || e.srcElement;

        // find root element of slide
        var clickedListItem = closest(eTarget, function(el) {
            return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
        });

        if (!clickedListItem) {
            return;
        }

        // find index of clicked item by looping through all child nodes
        // alternatively, you may define index via data- attribute
        var clickedGallery = $(clickedListItem).parents(gallerySelector),
            childNodes = $(clickedListItem).parents(gallerySelector).find('figure'), //clickedListItem.parentNode.childNodes,
            numChildNodes = $(childNodes).length,
            nodeIndex = 0,
            index;
        for (var i = 0; i < numChildNodes; i++) {
            if (childNodes[i].nodeType !== 1) { 
                continue; 
            }

            if (childNodes[i] === clickedListItem) {
                index = nodeIndex;
                break;
            }
            nodeIndex++;
        }



        if (index >= 0) {
            // open PhotoSwipe if valid index found
            openPhotoSwipe(index, clickedGallery);
        }
        return false;
    };

    // parse picture index and gallery index from URL (#&pid=1&gid=2)
    var photoswipeParseHash = function() {
        var hash = window.location.hash.substring(1),
        params = {};

        if (hash.length < 5) {
            return params;
        }

        var vars = hash.split('&');
        for (var i = 0; i < vars.length; i++) {
            if (!vars[i]) {
                continue;
            }
            var pair = vars[i].split('=');  
            if (pair.length < 2) {
                continue;
            }           
            params[pair[0]] = pair[1];
        }

        if (params.gid) {
            params.gid = parseInt(params.gid, 10);
        }

        return params;
    };

    var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
        var pswpElement = document.querySelectorAll('.pswp')[0],
            gallery,
            options,
            items;
        items = parseThumbnailElements(galleryElement);
        // define options (if needed)
        options = {

            // define gallery index (for URL)
            galleryUID: $(galleryElement).attr('data-pswp-uid'), //galleryElement.getAttribute('data-pswp-uid'),

            getThumbBoundsFn: function(index) {
                // See Options -> getThumbBoundsFn section of documentation for more info
                var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
                    pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                    rect = thumbnail.getBoundingClientRect(); 

                return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
            },

        };

        // PhotoSwipe opened from URL
        if (fromURL) {
            if (options.galleryPIDs) {
                // parse real index when custom PIDs are used 
                // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
                for (var j = 0; j < items.length; j++) {
                    if (items[j].pid == index) {
                        options.index = j;
                        break;
                    }
                }
            } else {
                // in URL indexes start from 1
                options.index = parseInt(index, 10) - 1;
            }
        } else {
            options.index = parseInt(index, 10);
        }

        // exit if index not found
        if (isNaN(options.index)) {
            return;
        }

        if (disableAnimation) {
            options.showAnimationDuration = 0;
        }

        // Pass data to PhotoSwipe and initialize it
        gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
    };

    // loop through all gallery elements and bind events
    var galleryElements = document.querySelectorAll(gallerySelector + ' .imageGallery__item');

    for (var i = 0, l = galleryElements.length; i < l; i++) {
        galleryElements[i].setAttribute('data-pswp-uid', i + 1);
        galleryElements[i].onclick = onThumbnailsClick;
    }

    // Parse URL and open gallery if it contains #&pid=3&gid=1
    var hashData = photoswipeParseHash();
    if (hashData.pid && hashData.gid) {
        openPhotoSwipe(hashData.pid,  galleryElements[ hashData.gid - 1 ], true, true);
    }
};

function video($el) {
	this.$el = $el;

	// elements
	this.$player = this.$el.find(this.classes.player);
	this.$preview = this.$el.find(this.classes.preview);
	this.$iframe = this.$el.find(this.classes.iframe);
	this.$playButton = this.$el.find(this.classes.playButton);
	this.$youtubePlayer = '';

	// init
	this.init();
}

video.prototype = {
	constructor: video,

	classes: {
		player: '.js-video-player',
		preview: '.js-video-preview',
		playButton: '.js-video-playButton',
		iframe: '.js-video-iframe',
	},

	states: {
		active: 'is-active',
		playing: 'is-playing',
	},

	settings: {
		status: 'ready',
	},

	init: function() {
		this.addListener();
	},

	addListener: function() {
		this.$preview.on('click', {self: this}, this.previewClickHandler);
		this.$playButton.on('keypress', {self: this}, this.playButtonKeyPressHandler);
	},

	buttonClickHandler: function(event) {
		var self = event.data.self;
	},

	onPlayerReady: function(event) {
		var self = this;

		// play the video
		event.target.playVideo();

		// hide the thumbnail
		self.$el.addClass(self.states.playing);

		// setTimeout(function(){
		//   self.$thumbnail.css("display", "none");
		// }, 300);

	},
	playButtonKeyPressHandler: function(event) {
		var self = event.data.self;
    var keycode = (event.keyCode ? event.keyCode : event.which);
    if (keycode == 13) {
      self.$preview.trigger('click');
    }
    event.stopPropagation();
	},
	previewClickHandler: function(event) {
		var self = event.data.self;

		if (self.settings.status == 'ready') {
		  
			self.$el.addClass(self.states.active);
			self.$iframe.removeAttr('tabindex').focus();
			self.$youtubePlayer = new YT.Player(self.$iframe[0], {
				events: {
					'onReady': function(event) {
						self.onPlayerReady(event);
					},
					'onStateChange': function(event) {
						//video paused or ended
						if (event.data == YT.PlayerState.ENDED) {
							self.$el.removeClass(self.states.playing).removeClass(self.states.active);
							self.$iframe.attr('tabindex', '-1').blur();
						}
					},
				},
				
			});

		} else if (self.settings.status == 'active') {
	  		self.$el.removeClass(self.states.playing);
		}
	},
};

function form($el) {
    this.$el = $el;
    this.$fields = this.$el.find(this.classes.field);
    this.$groups = this.$el.find(this.classes.group);
    this.$dropzone = this.$el.find(this.classes.dropzone);
    this.$dropzoneAddButton = this.$el.find(this.classes.dropzoneAddButton);
    this.$errorLabel = this.$el.find(this.classes.fieldError);
    this.$validatedForm = '';
    this.$submitButton = this.$el.find(this.classes.submitButton);
    this.$success = $(this.$el.attr('data-success'));
    this.$error = $(this.$el.attr('data-error'));
    this.$scrollto = $(this.$el.attr('data-scrollto'));
    this.$formDesc = $(this.$el.attr('data-desc'));

    this.$subject = this.$el.find(this.classes.subject);
    this.$complaintFields = this.$el.find(this.classes.complaintFields);

    this.init();
}

form.prototype = {
    constructor: form,

    classes: {
        field: '.js-form-field',
        group: '.js-form-group',
        fieldError: '.js-form-field-error',
        dropzone: '.js-dropzone',
        dropzoneAddButton: '.js-dropzone-add',
        submitButton: '.js-form-submit',
        subject: '.js-contact-subject',
        complaintFields: '.js-form-field-complaint'
    },

    states: {
        active: 'is-active',
        error: 'is-error',
        success: 'is-success',
    },

    settings: {
        recaptcha: false,
        processing: false,
    },

    te: function(name) {
        var category = $('.js-form').data('type');
        var label = $('.js-form').data('post_slug');
        var action = name;

        if (category === 'contest') {
            setTimeout(function(){
                if (window['ga'] !== undefined) {
                    ga('send', 'event', category, action, label);
                }
            }, 500);
        }
    },

    init: function() {
        this.addListener();
        this.initForm();
        this.initFormValidation();
    },

    addListener: function() {
        this.$el.on('recaptchaResponseValid', {
            self: this
        }, this.recaptchaResponseValidHandler);
        this.$el.on('recaptchaResponseExpired', {
            self: this
        }, this.recaptchaResponseExpiredHandler);
        this.$fields.find('input, select, textarea').on('focusin', {
            self: this
        }, this.fieldFocusInHandler);
        this.$fields.find('input, select, textarea').on('change', {
            self: this
        }, this.fieldChangeHandler);
        this.$fields.find('input, select, textarea').on('focusout', {
            self: this
        }, this.fieldFocusOutHandler);
        this.$submitButton.on('click', {
            self: this
        }, this.submitFormHandler);
        this.$dropzoneAddButton.on('click', {
            self: this
        }, this.dropzoneAddButtonHandler);
        this.$dropzoneAddButton.on('keypress', {
            self: this
        }, this.dropzoneAddButtonKeypressHandler);
        this.$errorLabel.on('click', {
            self: this
        }, this.errorLabelClickHandler);
        this.$subject.on('change', {
            self: this
        }, this.subjectChangeHandler);
        $('.form__checkbox_pseudo').on('keypress', {
            self: this
        }, this.customCheckRadioKeyPress)
    },

    initForm: function() {
        var self = this;
        this.uploadFields = [];
        $('.form__field--upload .dropzone').each(function() {
            var id = $(this).data('id');
            self.uploadFields[id] = false;
        })

        this.formType = this.$el.data('type');
        this.trackingName = this.$el.data('tracking-name');

        var csrf_token = $('input[name="csrf_token"]').val();
        this.$el.append('<input type="hidden" name="csrf_token" value="' + csrf_token + '"></input>');

        self.$validatedForm = self.$el.parsley({
            uiEnabled: false,
            trigger: 'focusout',
            validationThreshold: 3,
            excluded: ':hidden'
        });

        self.$dropzoneObject = self.$dropzone.each(function() {
            var url = $(this).data('url');
            var type = $(this).data('type');
            var multiple = $(this).data('multiple');

            var maxFilesize = 10;
            if (type === '.mp4') {
                maxFilesize = 40;
            }

            if (!type) {
                type = '.jpeg,.jpg,.png';
            }

            type = type.replace(',.', ', .');

            $(this).dropzone({
                params: {
                    slug: self.$el.data('post_slug')
                },
                url: url,
                paramName: 'file',
                uploadMultiple: false,
                maxFiles: multiple ? 10 : 1,
                maxFilesize: maxFilesize,
                acceptedFiles: type,
                dictDefaultMessage: 'Ziehe mit Drag&Drop ein ' + (type === '.mp4' ? 'Video' : 'Bild') + ' hierher oder verwende das Plussymbol um eine Datei auszuwählen',
                dictMaxFilesExceeded: 'Sie können leider nur eine Datei hochladen.',
                dictInvalidFileType: 'Sie können nur Dateien mit dem Typ ' + (type === '.mp4' ? '.mp4' : '.jpg oder .png') + ' hochladen',
                hiddenInputContainer: '.form__field--upload  .form__field__label',

                success: function(file, response) {
                    var responseJSON = jQuery.parseJSON(response);
                    var id = $(this.element).data('id');
                    if (responseJSON.status === 'error') {
                        // this.removeAllFiles(true);
                        $('.js-file-upload-error').html(responseJSON.message).show();
                        self.uploadFields[id] = this.element;
                        $(this.element).addClass('has-error');
                    } else {
                        self.uploadFields[id] = true;
                        $(this.element).removeClass('has-error');
                    }
                },
                init: function() {
                    var id = $(this.element).data('id');
                    self.uploadFields[id] = this.element;

                    var dz = this;
                    $(dz.hiddenFileInput).attr('id','contact-upload');

                    this.on('addedfile', function(file) {

                        var filesize = (file.size / (1024*1024)).toFixed(2);

                        if (filesize > maxFilesize) {
                            $('.js-file-upload-error').html('File tooooo big!').show();
                            $('.js-file-upload-error').parents('.js-form-field').addClass('is-error');

                            $('.js-form-error-summary').show().append('<tr class="js-dropzone"><th>Dateiupload</th><td>File tooooo big!</td></tr>').attr('role','alert');
                            self.$submitButton.attr('disabled', 'disabled');
                        }

                        file.previewElement.addEventListener('click', function() {
                            dz.removeFile(file);

                            $('.js-file-upload-error').html('').hide();
                            $('.js-file-upload-error').html('').hide();
                            $('.js-file-upload-error').parents('.js-form-field').removeClass('is-error');

                            $('.js-form-error-summary').find('tr.js-dropzone').remove();

                            if ($('.js-form-error-summary tr').length == 0) {
                                $('.js-form-error-summary').hide().removeAttr('role');
                                self.$submitButton.removeAttr('disabled');
                            }
                        });
                    });
                }
            });

        });

        this.te('Ready');

    },

    initFormValidation: function() {
        var self = this;

        self.$validatedForm.on('field:error', function() {
            $('.js-form-error-summary').find('tr.js-' + this.$element.attr('name')).remove();
            var innerText = this.$element.parents().eq(1).find('.form__field__label label').html();
            if (!innerText) {
                innerText = this.$element.attr('data-error-name');
            }

            $('.js-form-error-summary').show().append('<tr class=js-' + this.$element.attr('name') + '><th>' + innerText + '</th><td>' + this.getErrorsMessages() + '</td></tr>').attr('role','alert');
            this.$element
                .closest(self.classes.field)
                .addClass(self.states.error)
                .attr('aria-invalid','true')
                .removeClass(self.states.success)
                .find(self.classes.fieldError)
                .html('<span>' + this.getErrorsMessages() + '</span>');
        });

        self.$validatedForm.on('field:success', function() {
            var that = this.$element;
            // if (that.attr('required')) {
            $('.js-form-error-summary').find('tr.js-' + that.attr('name')).remove();
            if ($('.js-form-error-summary tr').length == 0) $('.js-form-error-summary').hide().removeAttr('role');
            that
                .closest(self.classes.field)
                .addClass(self.states.success)
                .removeClass(self.states.error)
                .removeAttr('aria-invalid')
                .find(self.classes.fieldError)
                .text('');
            // }
        });

        self.hasBeenValid = false;

        self.$validatedForm.on('field:validated', function() {
            var that = this.$element;
            if (that.closest(self.classes.field).length) {

                if (self.$el.find('[required]:visible').length === (self.$el.find('.' + self.states.success + ' [required]:visible').length - self.$el.find('.' + self.states.error).length) && self.settings.recaptcha) {
                    self.$submitButton.attr('data-title', self.$submitButton.attr('title'));
                    self.$submitButton.removeAttr('disabled').removeAttr('title').find('.sr-only').remove();
                    if (self.hasBeenValid === false) {
                        self.te('Form Valid');
                        self.hasBeenValid = true;
                    }
                } else {
                    self.$submitButton.attr('disabled', 'disabled').attr('title', self.$submitButton.attr('data-title'));
                    if (self.$submitButton.find('.sr-only').length == 0) {
                        self.$submitButton.append('<span class="sr-only">'+self.$submitButton.attr('data-title')+'</span>');
                    }
                    self.$submitButton.removeAttr('data-title');
                }
            }

        });

    },

    submitFormHandler: function(event) {
        var self = event.data.self;
        event.preventDefault();

        var uploadFilesValid = true;

        if (!self.settings.processing && self.$validatedForm.validate()) {

            self.$submitButton.attr('disabled', 'disabled');
            self.settings.processing = true;

            var data = self.$el.serialize();

            if ($('.dz-filename').length > 0) {
                data += '&contact-filename=' + $('.dz-filename span').html();
            }

            if (self.formType === 'contest') {
                var now = new Date();
                function addZero(num) {
                    if (num < 10) {
                        num = '0' + num;
                    }
                    return num;
                }
                var formData = {
                    date: now.getFullYear() + '-' + addZero(now.getMonth() + 1) + '-' + addZero(now.getDate()) + ' ' + addZero(now.getHours()) + ':' + addZero(now.getMinutes()) + ':' + addZero(now.getMinutes())
                };

                $('[form_data]').each(function() {
                    var $t = $(this);
                    var key = $t.attr('form_data');

                    if ($t.is('input') || $t.is('textarea')) {
                        var type = $t.attr('type');
                        if (type === 'checkbox' || type === 'radio') {
                            formData[key] = $('input[form_data="' + key + '"]:checked').val();
                        } else {
                            formData[key] = $t.val();
                        }
                    } else {
                        if ($t.hasClass('dropzone')) {
                            formData[key] = 'uploaddir_' + $t.find('.dz-filename').text().trim();
                        } else {
                            formData[key] = $t.text().trim();
                        }
                    }

                });


                data = {
                    form_data: formData,
                    contest: self.$el.data('post_slug'),
                    csrf_token: $('input[name="csrf_token"]').val()
                };

            }

            self.te('Form Submit')
            $.ajax({
                url: self.$el.attr('action'),
                type: self.$el.attr('method'),
                cache: false,
                data: data,
                dataType: 'json',
                success: function(data) {
                    if (data.status == 'success') {
                        self.te('Form Submit Success')
                        if (self.formType === 'contest') {
                            if (self.trackingName) {
                                fbq('track', 'CompleteRegistration', {content_name: self.trackingName});
                            }

                            window.location.href = '?success';
                            return;
                        } else {
                        self.$submitButton.removeAttr('disabled');

                        self.$el.velocity({
                            opacity: 0,
                        }, {
                            easing: app.settings.easing,
                            duration: app.settings.duration,
                            complete: function() {
                                self.$success.slideDown();
                                self.$formDesc.slideUp();
                                self.$el.slideUp(500);
                                $('html, body').animate({
                                    scrollTop: self.$scrollto.offset().top,
                                }, 500);
                            },
                        });

                        self.settings.processing = false;

                        }

                    } else {
                        self.te('Form Submit Invalid')
                        self.$error.text(data.message).slideDown();
                        self.$submitButton.removeAttr('disabled');
                        self.settings.processing = false;
                    }

                },
                error: function() {
                    self.te('Form Submit Error')
                    self.$submitButton.removeAttr('disabled');
                    self.settings.processing = false;
                },
            });

        } else {
            return;
        }
    },

    customCheckRadioKeyPress: function(event) {
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if (keycode == 13) {
            $(this).trigger('click');
        }
        event.stopPropagation();
    },

    validateForm: function() {
        var self = this;
        self.$el.find("input[required='required']").eq(1).trigger('focusout');
    },

    recaptchaResponseValidHandler: function(event) {
        var self = event.data.self;
        self.settings.recaptcha = true;
        self.validateForm();
    },

    recaptchaResponseExpiredHandler: function(event) {
        var self = event.data.self;
        self.settings.recaptcha = false;
        self.validateForm();
    },

    dropzoneAddButtonKeypressHandler: function(event) {
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if (keycode == 13) {
            $(this).trigger('click');
        }
        event.stopPropagation();
    },

    dropzoneAddButtonHandler: function(event) {
        var self = event.data.self;
        $(this).parent().trigger('click');
    },

    fieldFocusInHandler: function(event) {
        var self = event.data.self;
        $(this).closest(self.classes.field).addClass(self.states.active);
    },

    fieldFocusOutHandler: function(event) {
        var self = event.data.self;
        $(this).closest(self.classes.field).removeClass(self.states.active);
    },

    fieldChangeHandler: function() {
        $(this).trigger('focusout');
    },

    errorLabelClickHandler: function(event) {
        $(this).prev().focus();
        $(this).hide();
    },

    subjectChangeHandler: function(event) {
        var self = event.data.self;

        if ($(this).val() == 'Beschwerde/Produktreklamation') {
            self.$complaintFields.show();
        } else {
            self.$complaintFields.hide();
        }

        self.$validatedForm.refresh();
    }

};

function search($el) {
  this.$el            = $el;
  this.$page          = $(this.classes.page);

  this.$trigger       = $('body').find(this.classes.trigger);
  this.$input         = this.$el.find(this.classes.input);
  this.$header        = $('body').find(this.classes.header);
  this.$results       = this.$el.find(this.classes.results);
  this.$form          = this.$el.find(this.classes.form);
  this.$filter        = this.$el.find('.search__filter input');
  this.$filterLabel   = this.$el.find('.search__filter label');
  this.searchRequest  = undefined;
  this.typingTimeout  = undefined;
  this.$productCount  = this.$el.find(this.classes.productCount);
  this.$storyCount    = this.$el.find(this.classes.storyCount);
  this.$tooShortAlert = this.$el.find(this.classes.tooShortAlert);

  this.$open          = $('body').find(this.classes.open);
  this.$close         = $('body').find(this.classes.close);

  this.init();
}

search.prototype = {
  constructor: search,

  vars: {
    disabledTabNavSelectors : '.js-overlay, .header__navigation,.js-mobilemenu,.js-page-container,.js-page-footer, .js-header-skip-links, .js-footer-skip-links',
  },


  classes: {
    page: '.js-page',
    trigger: '.js-search-trigger',
    header: '.js-header, .js-mobile-header',
    canvas: '.js-canvas',
    input: '.js-search-input',
    results: '.js-search-results',
    form: '.js-search-form',
    productCount: '.js-search-productCount',
    storyCount: '.js-search-storyCount',
    tooShortAlert: '.js-search-too-short',
    close: '.close',
    open: '.open',
  },

  states: {
    active: 'is-active',
    isAnimating: 'is-animating',
    activeHeader: 'is-active-header',
  },

  settings: {
    isOpen: false,
    isAnimating: true,
  },


  init: function() {
    this.addListener();
    // this.checkIfSearchPage();
  },

  addListener: function() {
    this.$trigger.on('click', {self: this}, this.triggerClickHandler);
    // this.$input.on('keypress', {self: this}, this.triggerSearchHandler);
    this.$filterLabel.on('keypress', {self: this}, this.triggerFilterLabelHandler);
    // this.$filter.on('change', {self: this}, this.triggerSearchHandler);
    this.$form.find('form').on('submit', {self: this}, this.triggerSearchHandler);
    this.$el.on('toggleSearch', {self: this}, this.closeSearch);
  },


  checkIfSearchPage: function() {
    var self = this;
    setTimeout(function() {

      if (getUrlParameter('search')) {
        // self.toggleSearch();
        $('.js-search').addClass('is-active').addClass('is-animating');
        $('.js-header').addClass('is-active-header');
        self.$input.val(getUrlParameter('search'));
        $('.search__button').trigger('click');
      }

    }, 500);

  },

  submitSearchHandler: function(event) {
    var self = event.data.self;
    event.preventDefault();

    this.triggerSearchHandler(event);
  },

  triggerClickHandler: function(event) {
    var self = event.data.self;
    event.preventDefault();
    if (self.settings.isOpen) {
      app.enableTabNavOnOverlayClose(self.vars.disabledTabNavSelectors);
			self.$el.find('[tabindex]').attr('tabindex', '-1');
    }    else    {
      
      app.disableTabNavUnderOverlay(self.vars.disabledTabNavSelectors);
			self.$el.find('[tabindex]').removeAttr('tabindex');
			self.$el.find('[data-tabindex]').each(function() {
				$t = $(this);
				$t.attr('tabindex', $t.data('tabindex'));
			});
    }

    self.toggleSearch();
    if ($('.js-mobileMenu').hasClass('is-active'))    {
      $('.js-mobileMenu-trigger').trigger('click');
    }
  },

  triggerSearchHandler: function(event) {
    var self = event.data.self;
    event.preventDefault();
    //ga4
    	window.dataLayer = window.dataLayer || [];
					dataLayer.push({
            'event': 'ga4-event',
 						'event_name': 'search',
 						'parameter_name': 'search_term',
 						'parameter_value': self.$input.val(),
					});
        //console.log(dataLayer)
    if (self.$input.val().length > 3) {
      self.$tooShortAlert.hide();
      self.$input.removeAttr('aria-describedby').removeAttr('aria-invalid');
      self.performSearch();
    }    else    {
      self.$tooShortAlert.show();
      self.$input.attr('aria-describedby', 'search-error-info').attr('aria-invalid','true');
      self.$results.html('');
    }
  },

  triggerFilterLabelHandler :function(event) {
    var keycode = (event.keyCode ? event.keyCode : event.which);
    if (keycode == 13) {
      $(this).trigger('click');
    }
    event.stopPropagation();
  },

  performSearch: function() {

    var self = this;
    if (window['ga'] !== undefined) {
      ga('send', 'event', 'Search', 'search', self.$input.val());
    }

    if (self.searchRequest != undefined) {
    self.searchRequest.abort();
    }

    self.$results.velocity({
      opacity: 0,
      translateY: '-20px',
    }, {
      easing: app.settings.easing,
      duration: app.settings.duration * 2,
      // request new data
      complete: function() {
        self.searchRequest = $.ajax({
          url: self.$el.attr('data-endpoint'),
          type: 'POST',
          cache: false,
          data: {
            search: self.$input.val(),
            csrf_token: self.$form.find('input[name=csrf_token]').val(),
            filterProducts: self.$form.find('input[name=filter-products]:checked').val(),
            filterRecipeStory: self.$form.find('input[name=filter-recipe-story]:checked').val(),
          },
          dataType: 'json',
        }).done(function(data) {
            var html = data.html;
            //self.$page.off();
            // insert new data and animate in
            self.$results
              .empty()
              .append($(html))
              .velocity({
                opacity: 1,
                translateY: '0px',
              }, {
                easing: app.settings.easing,
                duration: app.settings.duration * 2,
              });

            self.$productCount.text('(' + data.productCount + ')');
            self.$storyCount.text('(' + data.storyCount + ')');

            //app.objects.initModules.initLocal(self.$page);
            if ($(html).find('.search__result__row--noResults').length > 0) {
              self.$input.attr('aria-describedby', 'search-no-results');
            } else {
              self.$input.removeAttr('aria-describedby');
            }

            setTimeout(function() {
              history.pushState({}, '', window.location.href.split('?search-phrase')[0] + '?search-phrase='+self.$input.val()+'&search-products='+self.$form.find('input[name=filter-products]').is(':checked')+'&search-stories-recipes='+self.$form.find('input[name=filter-recipe-story]').is(':checked'));
            }, 500);
            self.$el.find('.js-lazyload').each(function() {
              new lazyload($(this));
            });
        });
      },
    });

  },

  closeSearch: function(event) {
    var self = event.data.self;
    if (self.settings.isOpen) {
      self.toggleSearch();
      app.enableTabNavOnOverlayClose();
      url = window.location.split('?search-phrase')[0];
      alert('url');
      history.pushState({}, '', url);

    }
  },

  toggleSearch: function() {

    var self = this;

    if (self.$el.hasClass(self.states.active)) {

      self.$el.removeClass(self.states.active).attr('aria-hidden', 'true');
      self.$header.removeClass(self.states.activeHeader);
      self.$open.removeAttr('aria-hidden').removeAttr('tabindex');
      self.$close.attr('aria-hidden', 'true').attr('tabindex','-1');

      setTimeout(function() {
        self.$el.removeClass(self.states.isAnimating);
        self.settings.isOpen = false;
				// $('.js-page').css('-webkit-overflow-scrolling', 'touch');

        app.unLockScreen();

        setTimeout(function() {
          self.$results.empty();
          self.$input.removeAttr('aria-describedby').removeAttr('aria-invalid');
          self.$input.val('');
          self.$productCount.text('');
          self.$storyCount.text('');
        }, 500);
      }, 500);

      var pageurl = window.location.href;
      pageurl = pageurl.split("?search-phrase")[0];
      history.pushState({}, '', pageurl);

    } else {

      self.$el.addClass(self.states.isAnimating);
      self.$header.addClass(self.states.activeHeader);
      self.$close.removeAttr('aria-hidden').removeAttr('tabindex');
      self.$open.attr('aria-hidden', 'true').attr('tabindex','-1');

      setTimeout(function() {
        self.$el.addClass(self.states.active).removeAttr('aria-hidden');
				// $('.js-page').css('-webkit-overflow-scrolling', 'auto');

        app.lockScreen();

        self.settings.isOpen = true;
        self.$input.focus();
      }, 50);

    }

  },

  buttonClickHandler: function(event) {
    var self = event.data.self;
  },

};

function newsletter($el) {
  this.$el = $el;

  // elements
  this.$button = this.$el.find(this.classes.button);

  // init
  this.init();
}

newsletter.prototype = {
  constructor: newsletter,

  classes: {
    button: '.js-newsletter-button',
  },

  init: function() {
    this.addListener();
  },

  addListener: function() {
    this.$button.on('click', {self: this}, this.buttonClickHandler);
  },

  buttonClickHandler: function(event) {
    var self = event.data.self;
  },
};

function socialShare($el) {
    this.$el = $el;
    // elements
    this.$button = this.$el.find(this.classes.button);
    this.$storyShareWrapper = this.$el.find(this.classes.storyShareWrapper);
    // init
    this.init();
}
socialShare.prototype = {
    constructor: socialShare,
    vars: {
        listenerAdded: false,
    },
    classes: {
        trigger: 'js-share',
        linkShare: 'js-share-link',
        linkShareCopied: 'js-share-link-copied',
        storyShareWrapper: 'js-story-share-wrapper',
    },
    config: {
        default: {
            popupWidth: 520,
            popupHeight: 350,
            urlKey: 'url',
        },
        facebook: {
            url: 'https://www.facebook.com/sharer/sharer.php',
            urlKey: 'u',
        },
        twitter: {
            url: 'https://twitter.com/intent/tweet/',
        },
        linkedin: {
            url: 'https://www.linkedin.com/shareArticle',
        },
        googleplus: {
            url: 'https://plus.google.com/share',
        },
        pinterest: {
            url: 'https://www.pinterest.com/pin/create/button/',
            popupHeight: 'full',
            popupWidth: 'half',
        },
        // email: {
        //   overlay: 'ajax/share.html',
        // },
        whatsapp: {
            url: 'https://api.whatsapp.com/send',
            urlKey: 'text',
            popupHeight: 'full',
            popupWidth: 'half',
        },
        email: {
            url: 'mailto:',
            urlKey: 'subject',
            popupHeight: 'full',
            popupWidth: 'half',
        }
    },
    init: function () {
        this.addListener();
    },
    addListener: function () {
        if (this.vars.listenerAdded) { return; };
        jQuery(document)
            .on('click', '.' + this.classes.trigger, { self: this }, this.clickHandler)
        jQuery(document)
            .on('click', '.' + this.classes.linkShare, { self: this }, this.shareLinkHandler)
        this.vars.listenerAdded = true;
    },
    shareLinkHandler: function (event) {
        var self = event.data.self;
        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val(jQuery(this).data('shareUrl')).select();
        document.execCommand("copy");
        $temp.remove();
        if ($('.js-share-link-copied')) {
            $('.js-share-link-copied').addClass('is-visible');
            setTimeout(function () {
                $('.js-share-link-copied').removeClass('is-visible');
            }, 500);
        }
    },
    clickHandler: function (event) {
        event.preventDefault();
        var self = event.data.self;
        var $clicked = jQuery(this);
        var type = $clicked.data('type') || 'facebook';
        var shareUrl = $clicked.data('shareUrl') || escape(window.location.href);
        var mediaUrl = $clicked.data('mediaUrl') || '';
        var title = $clicked.data('eventLabel') || '';
        var $window = jQuery(window);
        var config = jQuery.extend({}, self.config.default, self.config[type]);
        if (!config.url) {
            console.error('Sharing is not setup for "' + type + '"');
            return;
        };
        var url = config.url;
        var appendText = $clicked.data('content') == 'storie' ? 'Schon gelesen? ' : $clicked.data('content') == 'recipe' ? 'Schon probiert? ' : '';
        var parameter = [];
        if (type === 'whatsapp') {
            parameter.push(config.urlKey + '=' + encodeURI(appendText + shareUrl));
            parameter = '?' + parameter.join('&');
            url += parameter;
        } else if (type === 'email') {
            parameter.push(config.urlKey + 'subject=' + title);
            parameter = '?' + parameter.join('&');
            url += parameter + '&body=' + encodeURI(appendText + shareUrl);
        } else {
            parameter.push(config.urlKey + '=' + shareUrl);
            if (mediaUrl != '') {
                parameter.push('media' + '=' + mediaUrl);
            }
            parameter = '?' + parameter.join('&');
            url += parameter + '&text=' + appendText;
        }
        // // Add parameter
        // var parameter = [];
        // parameter.push(config.urlKey + '=' + shareUrl);
        // if (mediaUrl != '') {
        //   parameter.push('media' + '=' + mediaUrl);
        // }
        // parameter = '?' + parameter.join('&');
        // if ($clicked.data('content') == 'storie'){
        //   if(type === 'whatsapp') {
        //     parameter = [];
        //     parameter.push(config.urlKey  + '=' + encodeURI('Sanja ' + shareUrl));
        //     parameter = '?' + parameter.join('&');
        //     url += parameter;
        //   } else {
        //     url += parameter + '&text=Schon gelesen?';
        //   }
        // }
        // else if ($clicked.data('content') == 'recipe'){
        //   url += parameter + '&text=Schon probiert?';
        // }
        // else {
        //   url += parameter;
        // }
        // Convert "string" to height
        if (config.popupHeight == 'full') {
            config.popupHeight = jQuery(window).height();
        };
        if (config.popupWidth == 'half') {
            config.popupWidth = jQuery(window).width() / 2;
        };
        var windowLeft = window.screenLeft ? window.screenLeft : window.screenX;
        var windowTop = window.screenTop ? window.screenTop : window.screenY;
        var top = windowTop + ($window.height() / 2 - config.popupHeight / 2);
        var left = windowLeft + ($window.width() / 2 - config.popupWidth / 2);
        if (type !== 'email') {
            window.open(url, 'sharePopUp', 'height=' + config.popupHeight + ', width=' + config.popupWidth + ', top=' + top + ', left=' + left + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
        } else {
            location.href = url;
        }
    },
};

function overlay($el) {
  this.$el    = $el;
  this.$close = $el.find('.overlay__close');
  this.$textLink  = $el.find('.overlay__text a'); 
  this.$audioPlayer  = $el.find('.overlay__audio'); 
  // init
  this.init();
}

overlay.prototype = {
  
  vars: {
    disabledTabNavSelectors : '.js-header,.js-mobilemenu,.js-page-container,.js-page-footer, .js-header-skip-links, .js-footer-skip-links',
  },

  init: function() {
    this.addListener();
    this.$el.addClass('is-visible').removeAttr('aria-hidden');
		// $('.js-page').css('-webkit-overflow-scrolling', 'auto');
    app.lockScreen();
    setTimeout(app.disableTabNavUnderOverlay(this.vars.disabledTabNavSelectors), 500);

    //$.cookie('cookie_agreement', 'true', { expires: 14 });
    if (this.$el.data('cookie')) {
      $.cookie(this.$el.data('cookie-title'), 'true', { expires: 14 });
    }

    this.$audioPlayer.mediaelementplayer({
      alwaysShowControls: true,
      features: ['playpause','progress','volume'],
      audioVolume: 'horizontal',
      audioWidth: '100%',
      audioHeight: 70,
      iPadUseNativeControls: true,
      iPhoneUseNativeControls: true,
      AndroidUseNativeControls: true
    });
  },

  addListener: function() {
    this.$close.on('click', {self: this}, this.closeClickHandler);
    this.$textLink.on('click', {self: this}, this.textLinkClickHandler);
  },

  closeClickHandler: function(event) {
    event.preventDefault();
    var self = event.data.self;

    app.enableTabNavOnOverlayClose(self.vars.disabledTabNavSelectors);
    self.$el.removeClass('is-visible').attr('aria-hidden', 'true');
		
    // $('.js-page').css('-webkit-overflow-scrolling', 'touch');
    app.unLockScreen();
    self.$audioPlayer.trigger("pause");

    self.$el.slideUp(400);
  },

  textLinkClickHandler: function(event) {
    if (window['ga'] !== undefined) {
      ga('send', 'event', 'Overlay Text Link', 'click', $(this).html());
    }
  },

};


function headerMain($el) {
	this.$el                  = $el;
	this.$page                = $(this.classes.page);
	this.$wrapper             = $el.find(this.classes.headerWrapper);
	this.$detailHeader        = $el.find(this.classes.detailHeader);
	this.$detailHeaderTrigger = $(this.classes.detailHeaderTrigger);
	this.$headerMain          = $el;
	// init
	this.init();
}

headerMain.prototype = {
	
	settings: {
		headerMobileDisplayWidth: 960,
		headerDetailDisplayWidth: 767,
	},
	
	classes: {
		page                : '.js-page',
		headerWrapper       : '.js-header-wrapper',
		detailHeader        : '.js-detailHeader',
		detailHeaderTrigger : '.js-productIngridients, .js-recipeIngridients',
		fixheaderTrigger    : '.js-header-fixed-trigger',
		swiperContainer     : '.js-imageSlider-container',
		swiperPagination    : '.js-imageSlider-pagination',
	},
	
	states: {
		pageWithFixedHeader : 'js-page-fixed-headerMain',
		fixed               : 'js-header-main-fixed',
		visible             : 'is-visible',
		animating           : 'is-animating',
		autoplaying         : true,
		headerDetailVisible : 'js-header-detail-header-visible',
	},
	
	init: function() {
		this.fixHeader(this);
		this.addListener();
	},
	
	addListener: function() {
		var t = this;
		$(window).on('scroll', function() {
			if ($(window).width() > t.settings.headerMobileDisplayWidth) {
				t.fixHeader(t);
			}
			if ($(window).width() > t.settings.headerDetailDisplayWidth) {
				if (t.$detailHeaderTrigger.length > 0) {
					t.showPrevNextHeader(t);
				}
			}
		});
		
		//scroll the content even when yout cursor is inside the fixed header
		$(document).on('mousewheel', '.js-header-main-fixed, .header__mobile', function(event) {
			event.preventDefault();
			var scroll = $(window).scrollTop();
			$('html, body').animate({scrollTop: scroll - event.originalEvent.wheelDeltaY}, 0);
			return true;
		});
		$(document).on('blur', t.classes.detailHeader + ' a:last', function(event) {
			$('.js-top-skip-link').focus();
		});
	},

	fixHeader: function(t)	{
		if (($(window).scrollTop() > t.$page.find(t.classes.fixheaderTrigger).height()) && !t.$el.hasClass(t.states.fixed))		{

			if (!$('.js-search').hasClass('is-active') && !$('.js-overlay').hasClass('is-visible')) {

				t.$el.addClass(t.states.fixed);
				t.$page.addClass(t.states.pageWithFixedHeader);
			}
		}		else if (($(window).scrollTop() < t.$page.find(t.classes.fixheaderTrigger).height()) && t.$el.hasClass(t.states.fixed))		{

			if (!$('.js-search').hasClass('is-active') && !$('.js-overlay').hasClass('is-visible')) {
				t.$el.removeClass(t.states.fixed);
				t.$page.removeClass(t.states.pageWithFixedHeader);
			}
		}
	},
	
	showPrevNextHeader: function(t)	{
		if (($(window).scrollTop() > t.$detailHeaderTrigger.position().top + $(t.classes.fixheaderTrigger).height()) && !t.$headerMain.hasClass(t.states.headerDetailVisible))		{
			t.$headerMain.addClass(t.states.headerDetailVisible);
			// t.$detailHeader.find('a').removeAttr('tabindex');
		}		else if (($(window).scrollTop() < t.$detailHeaderTrigger.position().top + $(t.classes.fixheaderTrigger).height()) && t.$headerMain.hasClass(t.states.headerDetailVisible))		{
			t.$headerMain.removeClass(t.states.headerDetailVisible);
			// t.$detailHeader.find('a').attr('tabindex', '-1');
		}
	},
};

function initModules($context) {
  this.initGlobal();
  this.initLocal($context);
}

 var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};

initModules.prototype = {
  constructor: initModules,

  initGlobal: function() {

    // Load YouTube API
    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    app.objects.page = new page();

    app.objects.preloader = new preloader();



  },

  initLocal: function($context) {

    $context.find('.js-slider').each(function() {
      new slider($(this));
    });

    $context.find('.js-tooltip').each(function() {
      new tooltip($(this));
    });

    $context.find('.js-featured').each(function() {
      new featured($(this));
    });

    $context.find('.js-productCategories').each(function() {
      new productCategories($(this));
    });

    $context.find('.js-hero').each(function() {
      new hero($(this));
    });

    $context.find('.js-products').each(function() {
      new products($(this));
    });

    $context.find('.js-productNutritions').each(function() {
      new productNutritions($(this));
    });

    $context.find('.js-productSteps').each(function() {
      new productSteps($(this));
    });

    $context.find('.js-moments').each(function() {
      new moments($(this));
    });

    $context.find('.js-recipeHeader').each(function() {
      new recipeHeader($(this));
    });

    $context.find('.js-imageSlider').each(function() {
      new imageSlider($(this));
    });

    $context.find('.js-video').each(function() {
      new video($(this));
    });

    $context.find('.js-form').each(function() {
      new form($(this));
    });

    $context.find('.js-sliderMobile').each(function() {
      new sliderMobile($(this));
    });

    $context.find('.js-mobileMenu').each(function() {
      new mobileMenu($(this));
    });

    $context.find('.js-search').each(function() {
      new search($(this));
    });

    $context.find('.js-newsletter').each(function() {
      new newsletter($(this));
    });

    $context.find('.js-share').each(function() {
      new socialShare($(this));
    });

    recaptchaRender();

    $context.find('.js-overlay').each(function() {
      new overlay($(this));
    });

    $context.find('.js-header-main').each(function() {
      new headerMain($(this));
    });

    $context.find('.js-header-mobile').each(function() {
      new headerMain($(this));
    });

    $context.find('.productCategoriesDetail').each(function() {
      new productCategoriesDetail($(this));
    });

    $context.find('.js-story-share-wrapper').each(function() {
      new socialShareStoryButtons($(this));
    });

    $context.find('.photoswipeGallery').each(function() {
      new initPhotoSwipeFromDOM('.photoswipeGallery');
    });

    $context.find('.js-recipe-rating').each(function() {
      new recipeRating($(this));
    });
    $context.find('.js-cookie').each(function() {
      new cookieAgreement($(this));
    });
    $context.find('.js-productHero').each(function() {
      new productHero($(this));
    });
    $context.find('.js-ga-event-trigger').each(function() {
      new gaEvents($(this));
    });
    $context.find('.js-tipps-zum-verfeinern').each(function() {
      new productMakeItBetter($(this));
    });
    $context.find('.js-titleTextVid').each(function() {
      new titleTextVid($(this));
    });
    $context.find('.js-contest').each(function() {
      new contest($(this));
    });
    $context.find('.js-contrast-switcher').each(function() {
      new contrast_switcher($(this));
    });
    $context.find('.js-lazyload').each(function() {
      new lazyload($(this));
    });
  },

};

function productCategoriesDetail($el) {
  this.$el = $el;

  // elements
  this.$items = this.$el.find(this.classes.item);
  // init
  this.init();
}

productCategoriesDetail.prototype = {
  constructor: productCategoriesDetail,

  classes: {
    item: '.productCategoriesDetail__item',
		
  },

  init: function() {
    if ($('html').is('.safari8, .ie10'))		{
			this.$items.matchHeight();
		}
  },
};

$(function() {
    ParallaxScroll.init();
});

var ParallaxScroll = {
    /* PUBLIC VARIABLES */
    showLogs: false,
    round: 1000,

    /* PUBLIC FUNCTIONS */
    init: function() {
        this._log('init');
        if (this._inited) {
            this._log('Already Inited');
            this._inited = true;
            return;
        }
        this._requestAnimationFrame = (function() {
          return  window.requestAnimationFrame       || 
                  window.webkitRequestAnimationFrame || 
                  window.mozRequestAnimationFrame    || 
                  window.oRequestAnimationFrame      || 
                  window.msRequestAnimationFrame     || 
                  function(/* function */ callback, /* DOMElement */ element) {
                      window.setTimeout(callback, 1000 / 60);
                  };
        })();
        this._onScroll(true);
    },

    /* PRIVATE VARIABLES */
    _inited: false,
    _properties: ['x', 'y', 'z', 'rotateX', 'rotateY', 'rotateZ', 'scaleX', 'scaleY', 'scaleZ', 'scale'],
    _requestAnimationFrame:null,

    /* PRIVATE FUNCTIONS */
    _log: function(message) {
        if (this.showLogs) console.log('Parallax Scroll / ' + message);
    },
    _onScroll: function(noSmooth) {
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        this._log('onScroll ' + scroll);
        $('[data-parallax]').each($.proxy(function(index, el) {
            var $el = $(el);
            var properties = [];
            var applyProperties = false;
            var style = $el.data('style');
            if (style == undefined) {
                style = $el.attr('style') || '';
                $el.data('style', style);
            }
            var datas = [$el.data('parallax')];
            var iData;
            for (iData = 2; ; iData++) {
                if ($el.data('parallax' + iData)) {
                    datas.push($el.data('parallax-' + iData));
                }                else {
                    break;
                }
            }
            var datasLength = datas.length;
            for (iData = 0; iData < datasLength; iData++) {
                var data = datas[iData];
                var scrollFrom = data['from-scroll'];
                if (scrollFrom == undefined) scrollFrom = Math.max(0, $(el).offset().top - windowHeight);
                scrollFrom = scrollFrom | 0;
                var scrollDistance = data['distance'];
                var scrollTo = data['to-scroll'];
                if (scrollDistance == undefined && scrollTo == undefined) scrollDistance = windowHeight;
                scrollDistance = Math.max(scrollDistance | 0, 1);
                var easing = data['easing'];
                var easingReturn = data['easing-return'];
                if (easing == undefined || !$.easing || !$.easing[easing]) easing = null;
                if (easingReturn == undefined || !$.easing || !$.easing[easingReturn]) easingReturn = easing;
                if (easing) {
                    var totalTime = data['duration'];
                    if (totalTime == undefined) totalTime = scrollDistance;
                    totalTime = Math.max(totalTime | 0, 1);
                    var totalTimeReturn = data['duration-return'];
                    if (totalTimeReturn == undefined) totalTimeReturn = totalTime;
                    scrollDistance = 1;
                    var currentTime = $el.data('current-time');
                    if (currentTime == undefined) currentTime = 0;
                }
                if (scrollTo == undefined) scrollTo = scrollFrom + scrollDistance;
                scrollTo = scrollTo | 0;
                var smoothness = data['smoothness'];
                if (smoothness == undefined) smoothness = 30;
                smoothness = smoothness | 0;
                if (noSmooth || smoothness == 0) smoothness = 1;
                smoothness = smoothness | 0;
                var scrollCurrent = scroll;
                scrollCurrent = Math.max(scrollCurrent, scrollFrom);
                scrollCurrent = Math.min(scrollCurrent, scrollTo);
                if (easing) {
                    if ($el.data('sens') == undefined) $el.data('sens', 'back');
                    if (scrollCurrent > scrollFrom) {
                        if ($el.data('sens') == 'back') {
                            currentTime = 1;
                            $el.data('sens', 'go');
                        }                        else {
                            currentTime++;
                        }
                    }
                    if (scrollCurrent < scrollTo) {
                        if ($el.data('sens') == 'go') {
                            currentTime = 1;
                            $el.data('sens', 'back');
                        }                        else {
                            currentTime++;
                        }
                    }
                    if (noSmooth) currentTime = totalTime;
                    $el.data('current-time', currentTime);
                }
                this._properties.map($.proxy(function(prop) {
                    var defaultProp = 0;
                    var to = data[prop];
                    if (to == undefined) return;
                    if (prop == 'scale' || prop == 'scaleX' || prop == 'scaleY' || prop == 'scaleZ') {
                        defaultProp = 1;
                    }                    else {
                        to = to | 0;
                    }
                    var prev = $el.data('_' + prop);
                    if (prev == undefined) prev = defaultProp;
                    var next = ((to - defaultProp) * ((scrollCurrent - scrollFrom) / (scrollTo - scrollFrom))) + defaultProp;
                    var val = prev + (next - prev) / smoothness;
                    if (easing && currentTime > 0 && currentTime <= totalTime) {
                        var from = defaultProp;
                        if ($el.data('sens') == 'back') {
                            from = to;
                            to = -to;
                            easing = easingReturn;
                            totalTime = totalTimeReturn;
                        }
                        val = $.easing[easing](null, currentTime, from, to, totalTime);
                    }
                    val = Math.ceil(val * this.round) / this.round;
                    if (val == prev && next == to) val = to;
                    if (!properties[prop]) properties[prop] = 0;
                    properties[prop] += val;
                    if (prev != properties[prop]) {
                        $el.data('_' + prop, properties[prop]);
                        applyProperties = true;
                    }
                }, this));
            }
            if (applyProperties) {
                if (properties['z'] != undefined) {
                    var perspective = data['perspective'];
                    if (perspective == undefined) perspective = 800;
                    var $parent = $el.parent();
                    if (!$parent.data('style')) $parent.data('style', $parent.attr('style') || '');
                    $parent.attr('style', 'perspective:' + perspective + 'px; -webkit-perspective:' + perspective + 'px; ' + $parent.data('style'));
                }
                if (properties['scaleX'] == undefined) properties['scaleX'] = 1;
                if (properties['scaleY'] == undefined) properties['scaleY'] = 1;
                if (properties['scaleZ'] == undefined) properties['scaleZ'] = 1;
                if (properties['scale'] != undefined) {
                    properties['scaleX'] *= properties['scale'];
                    properties['scaleY'] *= properties['scale'];
                    properties['scaleZ'] *= properties['scale'];
                }
                var translate3d = 'translate3d(' + (properties['x'] ? properties['x'] : 0) + 'px, ' + (properties['y'] ? properties['y'] : 0) + 'px, ' + (properties['z'] ? properties['z'] : 0) + 'px)';
                var rotate3d = 'rotateX(' + (properties['rotateX'] ? properties['rotateX'] : 0) + 'deg) rotateY(' + (properties['rotateY'] ? properties['rotateY'] : 0) + 'deg) rotateZ(' + (properties['rotateZ'] ? properties['rotateZ'] : 0) + 'deg)';
                var scale3d = 'scaleX(' + properties['scaleX'] + ') scaleY(' + properties['scaleY'] + ') scaleZ(' + properties['scaleZ'] + ')';
                var cssTransform = translate3d + ' ' + rotate3d + ' ' + scale3d + ';';
                this._log(cssTransform);
                $el.attr('style', 'transform:' + cssTransform + ' -webkit-transform:' + cssTransform + ' ' + style);
            }
        }, this));
        if (window.requestAnimationFrame) {
            window.requestAnimationFrame($.proxy(this._onScroll, this, false));
        }        else {
            this._requestAnimationFrame($.proxy(this._onScroll, this, false));
        }
    },
};

function socialShareStoryButtons($el) {
	this.$storyShareWrapper = $el;
	this.$page = $(this.classes.page);

	// elements
	this.$fixStop = $(this.classes.fixStop);

	// init
	this.init();
}

socialShareStoryButtons.prototype = {
	constructor: socialShareStoryButtons,

	settings : {
		minWidthWhenFixing: 1240,
	},

	vars: {
		bounds: [],
		triggers: [],
		scrollMagicController: null,
	},

	classes: {
		page: '.js-page',
		storyShareWrapper: '.js-story-share-wrapper',

		//classes of modules that have fullscreen width and are boundaries for the sticky social buttons
		fixStop: '.js-storyHeader, .js-imageSlider, .js-storyVideo, .js-storyAuthor',
	},

	init: function() {
		var self = this;

		self.reset();

		if (self.$storyShareWrapper.length > 0) {
			self.initFixing();

			$(window).resize(function() {
				self.initFixing();
			});
		}
	},
	initFixing: function() {
		var self = this;
		//for desktop( > 1240) enable sticky social buttons
		if (($(window).width() >= self.settings.minWidthWhenFixing) && (self.vars.scrollMagicController == null)) {

			//define scroll magic container for js-page
			self.vars.scrollMagicController = new ScrollMagic.Controller({
				container: self.$page,
				loglevel: 0,
			});

			//figure out the top and bottom bounds for the fullscreen modules
			self.$fixStop.each(function() {
				var $t = $(this);
				//console.log((typeof $t.prev().css('padding-bottom') != 'undefined') ? $t.prev().css('padding-bottom').replace('px','') : 'xxxx');
				var prevPaddingBottom = (typeof $t.prev().css('padding-bottom') !== 'undefined') ? parseInt($t.prev().css('padding-bottom').replace('px', '')) : 0;
				var nextPaddingTop = (typeof $t.next().css('padding-top') !== 'undefined') ? parseInt($t.next().css('padding-top').replace('px', '')) : 0;

				var top = $t.position().top - prevPaddingBottom - self.$storyShareWrapper.height();
				var bottom = $t.position().top + $t.outerHeight() + nextPaddingTop;
				self.vars.bounds.push({top: top, bottom: bottom});
			});

			//figure out the where the social buttons will be sticky
			for (var i = 0; i < self.vars.bounds.length - 1; i++)			{
				if (self.vars.bounds[i + 1]['top'] > self.vars.bounds[i]['bottom']) {
					self.vars.triggers.push({top: self.vars.bounds[i]['bottom'], bottom: self.vars.bounds[i + 1]['top']});
				}
			}

			//clone the social buttons for every section where they will be sticky
			for (var i = 1; i < self.vars.triggers.length; i++) {
				var $storyShareWrapperClone = this.$storyShareWrapper.clone();
				var top = self.vars.triggers[i]['top'] - self.$storyShareWrapper.parents().eq(1).position().top - self.$storyShareWrapper.parent().position().top;

				$storyShareWrapperClone.removeAttr('data-id').attr('data-id', i).css('top', top + 'px').find('span').attr('tabindex', '-1');

				// asked to disable https://loop-dev.atlassian.net/browse/JUMBLE-689
				// this.$storyShareWrapper.parent().append($storyShareWrapperClone);
			}

			//add scroll magic scene for every section
			$.each(self.vars.triggers, function(index) {
				new ScrollMagic.Scene({
								duration: this['bottom'] - this['top'],	 // the scene should last for a scroll distance of 100px
								offset: this['top'],			 // start this scene after scrolling for 50px
						})
						.setPin(self.classes.storyShareWrapper + '[data-id=' + index + ']') // pins the element for the the scene's duration
						.addTo(self.vars.scrollMagicController); // assign the scene to the controller

			});
		}
		//for mobile( < 1240) destroy sticky social buttons if initialized before
		else if (($(window).width() < self.settings.minWidthWhenFixing) && (self.vars.scrollMagicController != null)) {
			self.vars.scrollMagicController.destroy(true);
			$(self.classes.storyShareWrapper + '[data-id!=0]').remove();

			self.reset();
		}
	},

	reset: function() {
		this.vars.scrollMagicController = null;
		this.vars.bounds = [];
		this.vars.triggers = [];
	},
};

function recipeRating($el) {
  this.$el = $el;

  // elements
  this.$ratingButtons = this.$el.find(this.classes.button);
  this.$container = this.$el.find(this.classes.container);
  this.$counter = this.$el.find(this.classes.count);
  this.$recipeID = this.$el.closest(this.classes.parent).attr('data-post-id');

  this.settings =  {
  	rating: '',
  	count: '',
  };

  // init
  this.init();
}

recipeRating.prototype = {
  constructor: recipeRating,

  classes: {
    button: '.js-recipe-rating-item',
    container: '.js-recipe-rating-container',
    count: '.js-recipe-rating-count',
    parent: '.recipe__item, .recipeHeader',
  },

  states: {
  	active: 'is-active',
  },

  init: function() {
    this.addListener();
    this.settings.rating = this.$el.find('.' + this.states.active).length;
    this.settings.count = parseInt(this.$counter.attr('data-count'));
  },

  addListener: function() {
    this.$ratingButtons.on('click', {self: this}, this.buttonClickHandler);
    this.$ratingButtons.on('keypress', {self: this}, this.buttonKeyPressHandler);
    this.$ratingButtons.on('mouseenter focus', {self: this}, this.mouseenter);
    this.$ratingButtons.on('mouseleave blur', {self: this}, this.mouseleave);
  },

  mouseenter: function(event) {
    var self = event.data.self;

    self.$ratingButtons.removeClass(self.states.active);

    var index = $(this).index() + 1;

    self.$ratingButtons.each(function(itemIndex) {
    	if (index > itemIndex) {
    		$(this).addClass(self.states.active);
    	}
    });
  },

  mouseleave: function(event) {
    var self = event.data.self;
    self.$ratingButtons.removeClass(self.states.active);

    self.$ratingButtons.each(function(index) {
    	if (self.settings.rating > index) {
    		$(this).addClass(self.states.active);
    	}
    });
  },

  increaseCounter: function() {
    this.$counter.html('(' + (this.settings.count + 1) + ')');
    this.settings.count++;
  },
  buttonKeyPressHandler: function(event) {
    var keycode = (event.keyCode ? event.keyCode : event.which);
    if (keycode == 13) {
      $(this).trigger('click');
    }
    event.stopPropagation();
  },
  buttonClickHandler: function(event) {
    var self = event.data.self;
    var index = $(this).index() + 1;

    $.ajax({
      url: '/api/rating/', 
      type: 'POST',
      cache: false,
      data: {
      	recipeID: self.$recipeID,
      	rating: index,
      },
      dataType: 'json',
      success: function(data) {
         if (data.status == 'success') {
          self.increaseCounter();
          self.settings.rating = index;
         }
      },
    });
  },
};

function cookieAgreement($el) {
  this.$el = $el;

  // elements
  this.$button = this.$el.find(this.classes.button);

  // init
  this.init();
}

cookieAgreement.prototype = {
  constructor: featured,

  classes: {
    button: '.js-cookie-button',
  },

  init: function() {
    this.addListener();
    this.showCookieBanner();
  },

  showCookieBanner: function () {
    if(!$.cookie('cookie_agreement') || $.cookie('cookie_agreement') != 'true'){
      this.$el.show();
    }
  },

  addListener: function() {
    this.$button.on('click', {self: this}, this.buttonClickHandler);
    this.$button.on('keypress', {self: this}, this.buttonKeyPresskHandler);
  },

  buttonKeyPresskHandler: function(event) {
    var keycode = (event.keyCode ? event.keyCode : event.which);
    if (keycode == 13) {
      $(this).trigger('click');
    }
    event.stopPropagation();
  },

  buttonClickHandler: function(event) {
    var self = event.data.self;

    if ($(this).attr('href') == '#') {
      event.preventDefault();
    }

    $.cookie('cookie_agreement', 'true', { expires: 365 });

    self.$el.off().remove();
  },
};

function productHero($el) {
  this.$el = $el;

  // elements
  this.$visual = this.$el.find(this.classes.visual);
  this.$visualMain = this.$el.find(this.classes.visualMain);

  // init
  this.init();
}

productHero.prototype = {
  constructor: productNutritions,

  classes: {
    visual: '.productHero__visual',
    visualMain: '.productHero__visual__main',
  },

  init: function() {
    var $visualImg = this.$visualMain.find('img');
    if ($('.productHero__features').length == 0) {
      this.$visual.css({'width':'42%', 'padding-left':'15%', 'padding-right':'1%'});
    }
    this.$visual.show();
  },
};

function gaEvents($el) {

	this.$trigger                = $el;
	// init
	this.init();
}

gaEvents.prototype = {

	init: function() {
		this.addListener();
	},
	addListener: function() {
		this.$trigger.on('click', function(e){
			if (typeof ga !== 'undefined') {
				var ga4Trigger = $(this);
				if (ga4Trigger.data('ga4-event')) {
					var event = ga4Trigger.data('ga4-event')
					window.dataLayer = window.dataLayer || [];
					dataLayer.push({
						'event': 'ga4-event',
 						'event_name': event.event_name,
 						'parameter_name': event.parameter_name,
 						'parameter_value': event.parameter_value,
					});
					//console.log(dataLayer)
				}
				
				ga('send', 'event', $(this).data('event-category'), $(this).data('event-action'), $(this).data('event-label'));
			}
		});
	}
};
function productMakeItBetter($el) {
  this.$el = $el;
  // init
  this.init();
}

productMakeItBetter.prototype = {


  init: function() {

    if (this.$el.data('anchor')) {
      $self = this;
      
      $('html, body').animate({ scrollTop: $self.$el.position().top + $('.js-productDetailHeader').outerHeight() }, 200);
      
    }

  },
};

function titleTextVid($el) {
  this.$el = $el;

  // elements
  this.$player = this.$el.find(this.classes.player);
  this.$thumbnail = this.$el.find(this.classes.thumbnail);
  this.$iframe = this.$el.find(this.classes.iframe);

  this.$youtubePlayer = '';

  // init
  this.init();
}

titleTextVid.prototype = {
  constructor: titleTextVid,

  classes: {
    player: '.js-titleTextVid-player',
    thumbnail: '.js-titleTextVid-thumbnail',
    iframe: '.js-titleTextVid-iframe',
  },

  states: {
    active: 'is-active',
    playing: 'is-playing',
  },

  settings: {
    status: 'ready',
  },

  init: function() {
    this.addListener();
  },

  addListener: function() {
    this.$thumbnail.on('click', {self: this}, this.thumbnailClickHandler);
    this.$thumbnail.on('keypress', {self: this}, this.thumbnailKeyPressHandler);
  },

  onPlayerReady: function(event) {
    var self = this;

    // play the video
    event.target.playVideo();

    // hide the thumbnail
    self.$el.addClass(self.states.playing);

    setTimeout(function() {
      self.$thumbnail.css('display', 'none');
    }, 300);
   
  },
  
  thumbnailKeyPressHandler: function(event) {
      var keycode = (event.keyCode ? event.keyCode : event.which);
      if (keycode == 13) {
          $(this).trigger('click');
      }
      event.stopPropagation();
  },

  thumbnailClickHandler: function(event) {
    var self = event.data.self;

    self.$player.find('iframe').attr('tabindex','0').focus();

    if (self.settings.status == 'ready') {
      
      self.$el.addClass(self.states.active);
      self.$youtubePlayer = new YT.Player(self.$iframe[0], {
      events: {
        'onReady': function(event) {
          self.onPlayerReady(event);

        },
      },
    });

    } else if (self.settings.status == 'active') {
      self.$el.removeClass(self.states.playing);
    }

  },
};

function contest($el) {
  this.$el    = $el;
  // init
  this.init();
}

contest.prototype = {
  
  init: function() {
    self = this;
    if (this.getUrlVars().length > 0 && this.getUrlVars()[0] == 'gewinnspiel-formular') {
      
      setTimeout(function() {
        $('html, body').animate({
          scrollTop: self.$el.prev().offset().top - $('.js-header-wrapper').outerHeight()
        }, 500);

        history.pushState(null, null, window.location.href.replace('?gewinnspiel-formular',''));
      }, 500);
    }

  },

  getUrlVars: function() {
    var vars = []; 
    var hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i];
        vars.push(hash);
    }
    
    return vars;
  },

};


function contrast_switcher($el) {
  this.$el = $el;

  this.init();
}

contrast_switcher.prototype = {
  constructor: contrast_switcher,

  init: function() {

    this.$el.on('click', this.switchContrast)

  },

  switchContrast: function() {
    $('body').toggleClass('high-contrast');
    $('.js-mobileMenu-trigger.is-active').trigger('click');
  }

}
//add simple support for background images:
function lazyload($el) {
    this.$el = $el;
    this.init();
}

lazyload.prototype = {
    constructor: lazyload,
    init: function () {
        var el = this.$el[0];
        var iswebp = this.convert(el);
        this.lazyLoad(el);
    },

    lazyLoad: function(element) {
        if (element.classList.contains('is-lazyloaded')) return false;

        element.classList.add('is-lazyloaded');
        if (element.hasAttribute('data-src')) {
            var img = element.getAttribute('data-src')
            element.setAttribute('src', img);
            return true;
        } else if (element.hasAttribute('data-bg')) {
            var img = element.getAttribute('data-bg')
            element.style.backgroundImage = "url('" + img + "')";
            return true;
        }
        return false;
    },

    convert: function(element) {
        if (!Modernizr.webp) return false;

        // var element = e.target;
        if (element.tagName === 'IMG') {
            var parent = element.parentNode;

            // standard image tags
            var img = element.getAttribute('data-src') || "";
            if (img.includes(".webp")) return true;
            var webpImage = img.replace('.jpg', '.jpg.webp').replace('.png', '.png.webp').replace('.jpeg', '.jpeg.webp');
            if (webpImage && validImage(webpImage)) {
                element.setAttribute('data-src', webpImage);
                return true;
            }
        } else {
            // background images
            var img = element.getAttribute('data-bg') || "";
            if (img.includes(".webp")) return true;
            webpImage = img.replace('.jpg', '.jpg.webp').replace('.png', '.png.webp').replace('.jpeg', '.jpeg.webp');
            if (webpImage && validImage(webpImage)) {
                element.setAttribute('data-bg', webpImage);
                return true;
            }
        }

        return false;
    }
};
var lazySizes = {
    cfg: {
        init: false,
        customMedia: {
            '--mobile': '(max-width: 767px)',
            '--tabvar': '(max-width: 1023px)',
            '--wide': '(max-width: 1279px)',
        }
    }

};

var sourceExpression = true;
var sourceRegularExpression;
var urlHelper = document.createElement('a');

var validImage = function(url) {
    if (!url || !sourceExpression) {
        return false;
    }

    urlHelper.href = url;
    var absoluteUrl = urlHelper.href;

    // check source expression
    if (!absoluteUrl.match(sourceRegularExpression)) {
        return false;
    }

    return true;
};

